
/* eslint-disable */
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { aemHostClient, eapiClient } from '../../../restClient';
import { Translations, convertStringToArray, convertStringToArrayForOption, convertStringToArrayForRadio, getNumberLengthFromString, isAdmin, isEmpty, isEmptyObject, savePageStateInSessionStorage, savePageStateInSessionStorageLevel2, setElementAttributes } from '../../../utils';
import EntitySearchBox from '../../common/EntitySearchBox/';
import SearchBox from '../../common/SearchBox/';
import Table from '../../common/Table/';
import { setCountryInfo, setCurrencyInfo } from '../../createAcase/actions/actionCreator';
import AutoCompleteTextBox from '../AutoCompleteTextBox/AutoCompleteTextBox';
import Dropdown from '../Dropdown/DropDown';
import InputText from '../InputBox/inputTextbox';
import Password from '../Password';
import Radiobtn from '../Radio/radioButton';
import { applyDataControlRules } from './dataControlRules';
import { applyFormFieldBulkRules, applyFormFieldRules } from './formFieldsVisibilityRules';


import { ACH_UK, RESIDENT_ONLY_ACCOUNT_COUNTRIES } from '../../../constants';
import { getAggregateFormComponents } from '../../SowBody/CustomerDetails/CaptureAccountDetails';
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../../common/Modal';
import FormButton from '../Btn';
import CCRRateBox from '../CCRRateBox';
import Checkbox from '../Checkbox';
import ComboBox from '../ComboBox';
import DateSelector from '../DateSelector/DateSelector';
import InputTextbox from '../InputBox/inputTextbox';
import InterestComboBox from '../InterestComboBox';
import MultiLineSelect from '../MultiLineSelect';
import NestedCheckBox from '../NestedCheckBox/NestedCheckBox';
import OptionalTextBox from '../OptionalTextBox';
import PersistLink from '../PersistLink';
import RadioButton from '../Radio/radioButton';
import SingleLineSelect from '../SingleLineSelect';
import SweepFrequencyPicker from '../SweepFrequencyPicker';
import SweepTimePicker from '../SweepTimePicker';
import './dynamic.css';

class Dynamicform extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formTouched: props.formTouched,
      formData: {},
      formInvalid: props.formInvalid,
      randomIdx: Math.random().toString(36).slice(2)
    };
    this.inValidFieldsLoading = false;
    this.inValidFields = [];
    this.dropDownResourceUrls = [];
  }

  isReadOnly = () => {
    const { customer, isCustAck, caseMenu } = this.props || {}
    return customer && (customer.roleDetails.customer || isCustAck) ||
      (caseMenu && caseMenu.isEditing &&
        (caseMenu.editingUserEmail !== customer.emailAddress))
  }

  isResidentOnlyAccountCountry = () => {
    const { formData = {}, country } = this.props.properties;
    const selectedCountry = this.state.formData['country'] || formData['country'];
    const countryId = selectedCountry && selectedCountry.value ? selectedCountry.value : country;
    return RESIDENT_ONLY_ACCOUNT_COUNTRIES.has(countryId);
  }

  getSelectedResidency = () => {
    const { formData = {} } = this.props.properties;
    return this.state.formData['residency'] !== undefined
      ? this.state.formData['residency']
      : formData['residency'];
  }

  prepareAccountFormDropdowns = (lang, countryFromNextProps) => {
    let country = this.props.properties.country || countryFromNextProps
    if (country) {
      let apiUrl = '/product/countryInfo/' + country
      if (lang === 'Spanish') {
        apiUrl = '/product/countryInfo/' + country + '?lang=es'
      } else if (lang === 'Bahasa') {
        apiUrl = '/product/countryInfo/' + country + '?lang=ba'
      }
      eapiClient(apiUrl)
        .then(({ data }) => {
          var selectedType = data.responseData.associations.filter(_countryInfo => {
            return _countryInfo.id === this.props.properties.accountType;
          });
          let currency = selectedType[0] !== undefined ? selectedType[0].associations : [];
          this.props.setCountryInfo(data.responseData.associations);
          this.props.setCurrencyInfo(currency);
        });
    }
  }

  componentDidMount() {
    var aemUrl = this.props.url;
    let formInvalid = this.state.formInvalid;
    if (this.props.mode === "edit") {
      aemUrl = this.props.productType === "gls-sow-create-entity" ? aemUrl : aemUrl.replace("create-", "edit-");
      formInvalid = false;
    }
    if (this.props.properties.actualMode !== undefined && this.props.properties.actualMode !== 'edit') {
      aemUrl = aemUrl.replace("edit-", "create-");
      this.addInvalidField('accountNumber');
      formInvalid = true;
    }
    this.inValidFieldsLoading = true;

    if (!this.props.isRepeatingComponentWithSameResourceUrl) {
      aemHostClient(aemUrl)
        .then(({ data }) => {
          this.updateFormSchema(data, formInvalid)
        });
    }

    if (this.props.mode === 'edit') {
      this.setState({ formData: { ...this.props.properties.formData } });
    }

    // setting data required for account form in case body in basic details
    if (this.props.mode === 'edit' && this.props.properties.editType === "capture-product-account-basic-details") {
      this.prepareAccountFormDropdowns(this.props.lang);
    }

    var getCurrentDropDown = window.sessionStorage.getItem("getCurrentDropDown");
    var getCurrentDropDownValue = window.sessionStorage.getItem('key' + getCurrentDropDown);

    if (getCurrentDropDown !== null) {
      var getCurrentDropDownName;
      if (isNaN(parseInt(getCurrentDropDown.substring(getCurrentDropDown.length - 1)))) {
        getCurrentDropDownName = getCurrentDropDown;
      } else {
        //The function getNumberLengthFromString gets length of number appended at last with the given string, e.g achAccountsId11 -> returns 2
        var _indexLength = getNumberLengthFromString(getCurrentDropDown);
        getCurrentDropDownName = getCurrentDropDown.substring(0, getCurrentDropDown.length - _indexLength);
      }
    }

    if (getCurrentDropDown === 'deliverTo' && this.props.properties.formData.deliverTo !== getCurrentDropDownValue && getCurrentDropDownValue !== null) {
      this.setState({ formData: { ...this.props.properties.formData, deliverTo: getCurrentDropDownValue } });
    }
    if (getCurrentDropDown === 'addressLid' && this.props.properties.formData.addressLid !== getCurrentDropDownValue && getCurrentDropDownValue !== null) {
      this.setState({ formData: { ...this.props.properties.formData, addressLid: getCurrentDropDownValue } });
    }
    if (getCurrentDropDown === 'franceAddress' && this.props.properties.formData.franceAddress !== getCurrentDropDownValue && getCurrentDropDownValue !== null) {
      this.setState({ formData: { ...this.props.properties.formData, franceAddress: getCurrentDropDownValue } });
    }
    if (getCurrentDropDown === 'accountId' && this.props.properties.formData.accountId !== getCurrentDropDownValue && getCurrentDropDownValue !== null) {
      this.setState({ formData: { ...this.props.properties.formData, accountId: getCurrentDropDownValue } }, () => { this.formblur() });
    }
    if (this.props.properties.editType === 'create-existing-echannel-other-account' && this.props.mode === 'edit') {
      if (getCurrentDropDown === 'accountId' && this.props.properties.formData.accountId !== getCurrentDropDownValue && getCurrentDropDownValue !== null) {
        this.setState({ formData: { ...this.props.properties.formData, accountId: getCurrentDropDownValue } }, () => { this.formblur() });
      } else {
        this.setState({ formData: { ...this.props.properties.formData } }, () => { this.formblur() });
      }

    }
    if (getCurrentDropDown === `personalHomeAddress${this.props.properties.formData.accountSignatoryId}` && this.props.properties.formData.personalHomeAddress !== getCurrentDropDownValue
      && getCurrentDropDownValue !== null) {
      this.setState({ formData: { ...this.props.properties.formData, personalHomeAddress: getCurrentDropDownValue } });
    }
    if (this.props.setFormRandomIdx) {
      this.props.setFormRandomIdx(this.state.randomIdx)
    }
    if (this.state.formData['caseRequestorSearch'] !== undefined) {
      this.removeInvalidField("caseRequestorSearch")
    }
    if (this.state.formData['migrationCustomer'] !== undefined) {
      this.removeInvalidField("migrationCustomer")
    }
    if (this.state.formData['negotiated'] !== undefined) {
      this.removeInvalidField("negotiated")
    }
    if (this.state.formData['outputDocumentType'] !== undefined) {
      this.removeInvalidField("outputDocumentType")
    }
  }

  updateFormSchema = (data = {}, formInvalid) => {
    const formItems = data.guideContainer.rootPanel.items;
    this.setState({ formSchema: data, formInvalid });

    this.props.getFormSchema && this.props.getFormSchema(data)

    // indentifying mandatory fields
    if (this.props.mode !== "edit" || this.props.forceValidations) {
      for (const elementKey in formItems) {
        if ((elementKey.startsWith('guide') || elementKey.startsWith('type_ahead_caseRequestorSearch')) &&
          formItems[elementKey].mandatory &&
          formItems[elementKey].mandatory === "true" &&
          (formItems[elementKey].isVisible === undefined || formItems[elementKey].isVisible === "true")) {
          this.addInvalidField(formItems[elementKey].name);
        }
      }
    }
    this.inValidFieldsLoading = false;
  }

  componentWillReceiveProps(nextProps) {
    // applying bulk rules
    applyFormFieldBulkRules(nextProps.properties, this.state.formData);
    if (this.props.properties.existingEntityData !== undefined && this.props.properties.formData['profileOwner'] !== undefined) {
      if (nextProps.properties.existingEntityData.length !== this.props.properties.existingEntityData.length) {
        //this.setState({formData: {...this.props.properties.formData}});
        this.setState({
          formData: {
            ...this.state.formData,
            ['otherEntityProfileOwner']: {
              name: nextProps.properties.formData['profileOwner'].name,
              value: nextProps.properties.formData['profileOwner'].value
            }
          }

        }, () => { })
      }
    }

    if (nextProps.properties.formData['tradingName'] !== undefined && nextProps.properties.formData['otherEntityAccountHolder'] !== undefined && nextProps.properties.formData.accountId !== undefined) {
      //this.setState({formData: {...this.props.properties.formData}});
      this.setState({
        formData: {
          ...this.state.formData,
          otherEntityAccountHolder: nextProps.properties.formData['otherEntityAccountHolder']
        }

      }, () => { })
    }
    if (nextProps.properties.formData.otherAccountHolder !== undefined && nextProps.properties.formData['otherEntityAccountHolder'] !== undefined) {
      if (nextProps.properties.formData.otherAccountHolder === true && nextProps.properties.formData['otherEntityAccountHolder'].value !== 'other' && nextProps.properties.formData['accountId'] === undefined) {
        this.setFieldValidtionState('accountId', 'invalid');
      }
    }
    if (this.state.formData['accountId'] !== undefined) {
      if (nextProps.properties.formData['accountId'] !== this.props.properties.formData['accountId']) {
        document.addEventListener("click", this.formblur());
      }
    }
    if (this.props.mode === 'edit' && this.props.properties.editType === "capture-product-account-basic-details" && (nextProps.lang !== this.props.lang || nextProps.properties.country !== this.props.properties.country)) {
      this.prepareAccountFormDropdowns(nextProps.lang, nextProps.properties.country);
    }
    if (this.props.properties !== undefined && this.props.properties.editType === "add-manual-case-basic-details") {
      if (nextProps.CaseRecordToggle !== undefined) {
        if (nextProps.CaseRecordToggle !== this.props.CaseRecordToggle) {
          this.addInvalidField("businessSegment");
          this.addInvalidField("countryOfIncorporation");
          this.addInvalidField("glcmImplementation");
          this.addInvalidField("financialInstitution");
          this.addInvalidField("csProjectNumber");
          this.addInvalidField("registeredName");
          if (document.getElementById('projectNoField')) {
            this.addInvalidField("cmpProjectID");
          }
        }
      }
      if (nextProps.resetData !== undefined) {
        if (nextProps.resetData !== this.props.resetData) {
          const prevState = this.state.formData;
          this.setState({
            formData: {
              CaseID: prevState.CaseID,
              CaseRecordType: prevState.CaseRecordType,
              GdocsTerms: this.props.properties.GdocsTerms
            }
          })
          this.addInvalidField("businessSegment");
          this.addInvalidField("countryOfIncorporation");
          this.addInvalidField("glcmImplementation");
          this.addInvalidField("financialInstitution");
          this.addInvalidField("csProjectNumber");
          if (this.state.formData && "projectNo" in this.state.formData) {
            this.addInvalidField("cmpProjectID");
          }
        }
      }

      if (nextProps.CreateNewToggle !== undefined) {
        if (nextProps.CreateNewToggle !== this.props.CreateNewToggle) {
          const prevState = this.state.formData;
          this.setState({
            formData: {
              CaseID: prevState.CaseID,
              CaseRecordType: prevState.CaseRecordType,
              GdocsTerms: this.props.properties.GdocsTerms
            }
          })
          this.addInvalidField("businessSegment");
          this.addInvalidField("countryOfIncorporation");
          this.addInvalidField("glcmImplementation");
          this.addInvalidField("financialInstitution");
          this.addInvalidField("csProjectNumber");
          this.addInvalidField("cmpProjectID");
        }
      }

      if (nextProps.ResetForm !== undefined) {
        if (nextProps.ResetForm !== this.props.ResetForm) {
          this.setState({ formData: {} })
          this.addInvalidField("businessSegment");
          this.addInvalidField("countryOfIncorporation");
          this.addInvalidField("glcmImplementation");
          this.addInvalidField("financialInstitution");
          this.addInvalidField("csProjectNumber");
          this.addInvalidField('cmpProjectID');
          this.addInvalidField("registeredName");
          document.getElementById("csProjectNumberField") !== null ? document.getElementById("csProjectNumberField").classList.add('noDisplay') : '';
          document.getElementById("cmpProjectIDField") !== null ? document.getElementById("cmpProjectIDField").classList.add('noDisplay') : '';

          if (document.getElementById("manual_case-button_checkAvailability")) {
            setElementAttributes(document.getElementById("manual_case-button_checkAvailability"), { style: { display: "none" } })
          }
          if (document.getElementById("manual_case-button_search")) {
            setElementAttributes(document.getElementById("manual_case-button_search"), { style: { display: "none" } })

          }
          if (document.getElementById('searchText')) {
            setElementAttributes(document.getElementById('searchText'), { readOnly: true })
          }
          if (document.getElementById('customer-search-container')) {
            setElementAttributes(document.getElementById('customer-search-container'), { style: { display: "block" } })
          }
        }
      }
      if ((this.props.properties.formData.projectNo !== nextProps.properties.formData.projectNo) && nextProps.properties.formData.projectNo) {
        this.setState({ formData: { ...this.state.formData, projectNo: nextProps.properties.formData.projectNo } })
      }
    }
    if (nextProps.msaCases) {
      this.removeInvalidField("glcmImplementation")
      this.removeInvalidField("countryOfRegistration");
      this.removeInvalidField("financialInstitution");
      this.removeInvalidField("businessSegment");
      this.removeInvalidField("GdocsTerms");

    }

    if (nextProps.productType === "gls-sow-create-entity" || nextProps.productType === "gls-sow-edit-entity") {
      if (nextProps.properties && nextProps.properties.formData && (nextProps.properties.formData.registeredName !== this.state.formData.registeredName && nextProps.properties.formData.countryOfIncorporation !== this.state.countryOfIncorporation)) {
        this.setState({ formData: { ...this.state.formData, registeredName: nextProps.properties.formData.registeredName, countryOfIncorporation: nextProps.properties.formData.countryOfIncorporation } })
      }
    }

    if (nextProps.productType === "gls-sow-edit-entity") {
      if (nextProps.properties && nextProps.properties.formData && (nextProps.properties.formData.salesManagerName !== this.state.formData.salesManagerName)) {
        this.setState({ formData: { ...this.state.formData, salesManagerName: nextProps.properties.formData.salesManagerName } })
      }
    }
    if (nextProps.productType === "gls-sow-edit-entity") {
      if (nextProps.properties && nextProps.properties.formData && (nextProps.properties.formData.salesManagerEmail !== this.state.formData.salesManagerEmail)) {
        this.setState({ formData: { ...this.state.formData, salesManagerEmail: nextProps.properties.formData.salesManagerEmail } })
      }
    }
    if (nextProps.productType === "gls-sow-edit-entity") {
      if (nextProps.properties && nextProps.properties.formData && (nextProps.properties.formData.globalSalesManagerName !== this.state.formData.globalSalesManagerName)) {
        this.setState({ formData: { ...this.state.formData, globalSalesManagerName: nextProps.properties.formData.globalSalesManagerName } })
      }
    }
    if (nextProps.productType === "gls-sow-edit-entity") {
      if (nextProps.properties && nextProps.properties.formData && (nextProps.properties.formData.globalSalesManagerEmail !== this.state.formData.globalSalesManagerEmail)) {
        this.setState({ formData: { ...this.state.formData, globalSalesManagerEmail: nextProps.properties.formData.globalSalesManagerEmail } })
      }
    }

    if (this.props.isRepeatingComponentWithSameResourceUrl &&
      (JSON.stringify(this.props.cachedResourceData) !== JSON.stringify(nextProps.cachedResourceData)) ||
      (!isEmptyObject(nextProps.cachedResourceData) && isEmptyObject(this.state.formSchema))) {
      if (nextProps.cachedResourceData.formSchema) {
        this.updateFormSchema(nextProps.cachedResourceData.formSchema, this.state.formInvalid)
      }
    }
    if (this.state.formData['caseRequestorSearch'] !== undefined) {
      this.removeInvalidField("caseRequestorSearch")
    }
    if (this.state.formData['migrationCustomer'] !== undefined) {
      this.removeInvalidField("migrationCustomer")
    }
    if (this.state.formData['negotiated'] !== undefined) {
      this.removeInvalidField("negotiated")
    }
    if (this.state.formData['outputDocumentType'] !== undefined) {
      this.removeInvalidField("outputDocumentType")
    }
  }

  addInvalidField = (fieldName) => {
    if (this.inValidFields.indexOf(fieldName) === -1) {
      this.inValidFields.push(fieldName);
    }
  }

  setNewAccountField = (val) => val

  removeInvalidField = (fieldName) => {
    this.inValidFields.remove(fieldName);
  }
  componentDidUpdate() {
    if (this.state.formData['eChannelId'] === undefined && document.getElementsByName('eChannelId')[0] !== undefined) {
      document.getElementsByName('eChannelId')[0].value = '';
    }
    if (this.state.formData['apiProfileId'] === undefined && document.getElementsByName('apiProfileId')[0] !== undefined) {
      document.getElementsByName('apiProfileId')[0].value = '';
    }
    if (this.state.formData['eChannelIdOptional'] === undefined && document.getElementsByName('eChannelIdOptional')[0] !== undefined) {
      document.getElementsByName('eChannelIdOptional')[0].value = '';
    }
    if (this.state.formData['swiftBIC'] === undefined && document.getElementsByName('swiftBIC')[0] !== undefined) {
      document.getElementsByName('swiftBIC')[0].value = '';
    }
    if (this.state.formData['surAvailable'] === true && this.state.formData['eChannelType'].value === 'urn:hsbc:cmb:gdocs:products:taxonomies:echannelType:hsbcNet' && this.state.formData['surAvailable'] !== undefined && document.getElementsByName('surAvailable')[0] !== undefined) {
      document.getElementById('surField').classList.remove('noDisplay');
    }
    if (this.state.formData['surAvailable'] === false && this.state.formData['surAvailable'] !== undefined && document.getElementsByName('surAvailable')[0] !== undefined) {
      document.getElementById('surField').classList.add('noDisplay');
    }
    if (this.state.formData['otherProfileOwner'] === undefined && document.getElementsByName('otherProfileOwner')[0] !== undefined) {
      document.getElementsByName('otherProfileOwner')[0].value = '';
    }
    if (this.state.formData['tradingName'] === undefined && this.props.properties.editType === 'create-new-echannel-other-account' && document.getElementsByName('tradingName')[0] !== undefined) {
      document.getElementsByName('tradingName')[0].value = '';
    }
    if (this.state.formData['branchCode'] === '' && document.getElementsByName('branchCode')[0] !== undefined) {
      document.getElementsByName('branchCode')[0].value = '';
    }
    if (this.state.formData['accountNumber'] === '' && document.getElementsByName('accountNumber')[0] !== undefined) {
      document.getElementsByName('accountNumber')[0].value = '';
    }
    if (this.state.formData['city'] === '' && document.getElementsByName('city')[0] !== undefined) {
      document.getElementsByName('city')[0].value = '';
    }
    if (this.state.formData['bankName'] === '' && document.getElementsByName('bankName')[0] !== undefined) {
      document.getElementsByName('bankName')[0].value = '';
    }
    if (this.state.formData['otherBankName'] === '' && document.getElementsByName('otherBankName')[0] !== undefined) {
      document.getElementsByName('otherBankName')[0].value = '';
    }
    if (this.state.formData['addressLine1'] === '' && document.getElementsByName('addressLine1')[0] !== undefined) {
      document.getElementsByName('addressLine1')[0].value = '';
    }
    if (this.state.formData['addressLine2'] === '' && document.getElementsByName('addressLine2')[0] !== undefined) {
      document.getElementsByName('addressLine2')[0].value = '';
    }
    if (this.state.formData['addressLine3'] === '' && document.getElementsByName('addressLine3')[0] !== undefined) {
      document.getElementsByName('addressLine3')[0].value = '';
    }
    if (this.state.formData['state'] === '' && document.getElementsByName('state')[0] !== undefined) {
      document.getElementsByName('state')[0].value = '';
    }
    if (this.state.formData['postCode'] === '' && document.getElementsByName('postCode')[0] !== undefined) {
      document.getElementsByName('postCode')[0].value = '';
    }
    if (this.state.formData['currency'] === '' && document.getElementsByName('currency')[0] !== undefined) {
      document.getElementsByName('currency')[0].value = '';
    }
    if (this.state.formData['glcmImplementation'] && !this.props.customer.roleDetails.customer) {
      document.getElementById('projectNoField') && document.getElementById('projectNoField').classList.remove('noDisplay');
      if (this.state.formData['projectNo'] === 'CS') {
        document.getElementById('cmpProjectIDField') && document.getElementById('cmpProjectIDField').classList.add('noDisplay');
        document.getElementById('csProjectNumberField') && document.getElementById('csProjectNumberField').classList.remove('noDisplay');
      } else if (this.state.formData['projectNo'] === 'CMP') {
        document.getElementById('cmpProjectIDField') && document.getElementById('cmpProjectIDField').classList.remove('noDisplay');
        document.getElementById('csProjectNumberField') && document.getElementById('csProjectNumberField').classList.add('noDisplay');
      }
    } else {
      document.getElementById('projectNoField') && document.getElementById('projectNoField').classList.add('noDisplay');
      document.getElementById('cmpProjectIDField') && document.getElementById('cmpProjectIDField').classList.add('noDisplay');
      document.getElementById('csProjectNumberField') && document.getElementById('csProjectNumberField').classList.add('noDisplay');
    }
    if ((this.state.formData['csProjectNumber'] === undefined || this.state.formData['csProjectNumber'] === '') && document.getElementsByName('csProjectNumber')[0] !== undefined) {
      document.getElementsByName('csProjectNumber')[0].value = '';
    }
    if ((this.state.formData['cmpProjectID'] === undefined || this.state.formData['cmpProjectID'] === '') && document.getElementsByName('cmpProjectID')[0] !== undefined) {
      document.getElementsByName('cmpProjectID')[0].value = '';
    }

  }
  validateForm = () => {
    // form touched event will be fired only once
    if (this.state.formTouched === false) {
      const formEquals = JSON.stringify(this.props.properties.formData) === JSON.stringify(this.state.formData);
      this.setState({ formTouched: !formEquals });
    }
    if (this.inValidFieldsLoading === false && this.inValidFields.length === 0 && this.state.formInvalid === true) {
      this.setState({ formInvalid: false });
    }
  }
  setFormElementData = (value, name, isAggregate, formName, aggregateFormData, formIndex) => {
    this.setState((prevState, props) => {
      var formData = { ...prevState.formData };
      if (typeof isAggregate === "boolean" && isAggregate) {
        const { from, to, negativeCreditInterest, ...rest } = value || {}
        if (formData[formName] && formData[formName][formIndex]) {
          formData[formName][formIndex] = rest
        } else {
          if (!Array.isArray(formData[formName])) {
            formData[formName] = []
          }
          formData[formName].push(rest)
        }
      } else {
        //check if name in undefined.
        name !== undefined ? formData[name] = value : '';
      }

      formData = applyDataControlRules(formData, name, value, this.props.fieldPrefix, this.props.properties.editType);
      if ('accountType' in formData) {
        if (formData.accountType !== '') {
          this.setFieldValidtionState('accountType', 'valid');
        } else {
          this.setFieldValidtionState('accountType', 'invalid');
        }
      }
      if ('currency' in formData) {
        if (formData.currency !== '') {
          this.setFieldValidtionState('currency', 'valid');
        } else {
          this.setFieldValidtionState('currency', 'invalid');
        }
      }
      if ('cin' in formData && this.props.properties.editType === "add-ach-to-case") {
        const { achCredit, cin } = formData;
        if (!isEmpty(achCredit)) {
          let isUKCheck = this.validateField(achCredit)
          if (!isEmpty(isUKCheck)) {
            this.setState({
              formData: {
                ...this.state.formData,
                achCredit: achCredit,
                cin: cin,
              }
            })
          } else {
            achCredit.map(v => {
              if (v.name.indexOf(ACH_UK) == -1) {
                this.setState({
                  formData: {
                    ...this.state.formData,
                    achCredit: achCredit,
                    cin: '',
                  }
                })
              } else {
                this.setState({
                  formData: {
                    ...this.state.formData,
                    achCredit: [],
                    cin: '',
                  }
                })
              }
            })
          }

        } else {
          this.setState({
            formData: {
              ...this.state.formData,
              achCredit: [],
              cin: '',
            }
          })
        }
      }
      if ('glcmImplementation' in formData) {
        if (!document.getElementById('projectNoField')) {
          if (formData.glcmImplementation === true) {
            this.setState({ flag: false })
            if (formData.csProjectNumber !== undefined && formData.csProjectNumber.length < 10) {
              this.setFieldValidtionState('csProjectNumber', 'invalid');
            }
            else {
              this.setFieldValidtionState('csProjectNumber', 'valid');
            }
          } else {
            this.setState({ flag: true })
            delete formData['csProjectNumber'];
            this.setFieldValidtionState('csProjectNumber', 'valid');
          }
        } else {
          if (formData.glcmImplementation === true) {
            this.setState({ flag: false })
            if (formData.projectNo === 'CS' && formData.csProjectNumber !== undefined && formData.csProjectNumber.length < 10) {
              this.setFieldValidtionState('csProjectNumber', 'invalid');
            } else if (formData.projectNo === 'CMP' && formData.cmpProjectID !== undefined && formData.cmpProjectID.length < 9) {
              this.setFieldValidtionState('cmpProjectID', 'invalid');
            } else {
              this.setFieldValidtionState('csProjectNumber', 'valid');
              this.setFieldValidtionState('cmpProjectID', 'valid');
            }
          } else {
            this.setState({ flag: true })
            delete formData['csProjectNumber'];
            delete formData['cmpProjectID'];
            this.setFieldValidtionState('projectNo', 'valid');
            this.setFieldValidtionState('csProjectNumber', 'valid');
            this.setFieldValidtionState('cmpProjectID', 'valid');
          }
        }
      }

      if ('caseRequestorSearch' in formData && name === "caseRequestorSearch") {
        if (formData.caseRequestorSearch === 'Other') {
          // this.setState({ flag: false })
          if (formData['caseRequestorOther'] === undefined || formData['caseRequestorOther'] === "") {
            this.setFieldValidtionState('caseRequestorOther', 'invalid');
          }
        } else {
          //this.setState({ flag: true })
          formData['caseRequestorOther'] ? formData['caseRequestorOther'] = '' : '';
          this.setFieldValidtionState('caseRequestorOther', 'valid');
        }
      }

      if ('primaryCaseOwnerSearch' in formData && name === "primaryCaseOwnerSearch") {
        if (formData.primaryCaseOwnerSearch === 'Other') {
        } else {
          formData['primaryCaseOwnerOther'] ? formData['primaryCaseOwnerOther'] = '' : '';
        }
      }

      if ('secondaryCaseOwnerSearch' in formData && name === "secondaryCaseOwnerSearch") {
        if (formData.secondaryCaseOwnerSearch === 'Other') {
        } else {
          formData['secondaryCaseOwnerOther'] ? formData['secondaryCaseOwnerOther'] = '' : '';
        }
      }

      if ('other' in formData) {
        if (formData.other === true && (formData['otherEntityProfileOwner'] === undefined || formData['otherEntityProfileOwner'].value !== 'other')) {
          delete formData['profileOwnerInPack'];
          delete formData['profileOwner'];
          this.setFieldValidtionState('profileOwnerInPack', 'valid');
          this.setFieldValidtionState('profileOwner', 'valid');
          this.setFieldValidtionState('otherProfileOwner', 'valid');
          if (formData['otherEntityProfileOwner'] === undefined && formData['otherProfileOwner'] === undefined) {
            this.setFieldValidtionState('otherProfileOwner', 'invalid');
          }
        } else if (formData.other === true && formData['otherEntityProfileOwner'].value === 'other' && formData['otherProfileOwner'] === undefined) {
          this.setFieldValidtionState('otherProfileOwner', 'invalid');
        }
        else if (formData.other === true && formData['otherProfileOwner'] !== undefined && formData['otherProfileOwner'] !== '') {
          this.setFieldValidtionState('profileOwnerInPack', 'valid');
        }
        else {
          if (formData.other === false && formData.profileOwnerInPack === undefined) {
            delete formData['otherEntityProfileOwner'];
            delete formData['otherProfileOwner'];
            this.setFieldValidtionState('profileOwnerInPack', 'invalid');
            this.setFieldValidtionState('otherProfileOwner', 'valid');
          }
          else if (formData.other === false && this.props.productType === "add-create-cash-flow-forecasting-echannel" || this.props.properties.editType === 'convert-echannel') {
            this.setFieldValidtionState("profileOwner", "valid")
            this.setFieldValidtionState("country", "valid")
          }
        }
      }
      if ('otherAccountHolder' in formData && this.props.setValidationForAccounts) {
        if (formData.otherAccountHolder === true && (formData['otherEntityAccountHolder'] === undefined || formData['otherEntityAccountHolder'].value !== 'other')) {
          if (formData['otherEntityAccountHolder'] === undefined && formData['tradingName'] === undefined) {
            delete formData['accountId'];
            delete formData['accountHolder'];
            //this.setFieldValidtionState('otherEntityAccountHolder', 'invalid');
            this.setFieldValidtionState('accountId', 'invalid');
            this.setFieldValidtionState('accountHolder', 'valid');
          }
          if (formData.otherAccountHolder === false) {
            delete formData['accountHolder'];
            delete formData['tradingName'];
            this.setFieldValidtionState('accountHolder', 'valid');
            this.setFieldValidtionState('tradingName', 'valid');
            if (formData.accountId === undefined) {
              this.setFieldValidtionState('accountId', 'invalid');
            } else {
              this.setFieldValidtionState('accountId', 'valid');
            }
          }
        } if (formData['otherEntityAccountHolder'] !== undefined) {
          if (formData.otherAccountHolder === true && (formData['otherEntityAccountHolder'].value === 'other' && (formData['tradingName'] === undefined || formData['tradingName'] === ''))) {
            //this.setFieldValidtionState('tradingName', 'invalid');
            this.setFieldValidtionState('otherEntityAccountHolder', 'valid');
          }
          if (formData.otherAccountHolder === true && formData['otherEntityAccountHolder'].value !== 'other' && formData['accountId'] === undefined) {
            this.setFieldValidtionState('tradingName', 'valid');
            this.setFieldValidtionState('accountId', 'invalid');
          }
          if (formData.otherAccountHolder === true && (formData['otherEntityAccountHolder'].value === 'other' && (formData['tradingName'] !== undefined && formData['tradingName'] !== ''))) {
            this.setFieldValidtionState('tradingName', 'valid');
            if (formData['accountId'] === undefined)
              this.setFieldValidtionState('accountId', 'invalid');
          }
        }
        if ('accountId' in formData) {
          this.setFieldValidtionState('accountId', 'valid');
        }
        if (formData.otherAccountHolder === false && formData.accountHolder === undefined) {
          delete formData['otherEntityAccountHolder'];
          delete formData['tradingName'];
          delete formData['accountId'];
          this.setFieldValidtionState('accountHolder', 'invalid');
          this.setFieldValidtionState('tradingName', 'valid');
          this.setFieldValidtionState('otherEntityAccountHolder', 'valid');
          this.setFieldValidtionState('accountId', 'invalid');
        } if (formData.otherAccountHolder === false && formData.accountHolder !== undefined) {
          this.setFieldValidtionState('otherEntityAccountHolder', 'valid');
          this.setFieldValidtionState('accountHolder', 'valid');
          if (formData.accountId === undefined) {
            this.setFieldValidtionState('accountId', 'invalid');
          } else {
            this.setFieldValidtionState('accountId', 'valid');
          }
        }
      }
      if (name === 'accountId' && value !== '') {
        this.setFieldValidtionState('accountId', 'valid');
      }

      if (name === 'eChannelType' && value.value !== 'urn:hsbc:cmb:gdocs:products:taxonomies:echannelType:swiftNet') {
        this.setFieldValidtionState('swiftBIC', 'valid')
        formData['swiftBIC'] = ''
      }
      else if (name === 'eChannelType' && value.value === 'urn:hsbc:cmb:gdocs:products:taxonomies:echannelType:swiftNet') {
        if (formData['swiftBIC'] !== '' && formData['swiftBIC'] !== undefined) {
          this.setFieldValidtionState('swiftBIC', 'valid')
        } else {
          this.setFieldValidtionState('swiftBIC', 'invalid')
        }
      }
      if ((name === 'eChannelType' || name === 'convert-echannel') && value.value !== 'urn:hsbc:cmb:gdocs:products:taxonomies:echannelType:API') {
        this.setFieldValidtionState('apiProfileId', 'valid')
        formData['apiProfileId'] = ''
      }
      else if ((name === 'eChannelType' || name === 'convert-echannel') && value.value === 'urn:hsbc:cmb:gdocs:products:taxonomies:echannelType:API' && formData[''] !== '') {
        if (formData['apiProfileId'] !== '' && formData['apiProfileId'] !== undefined) {
          this.setFieldValidtionState('apiProfileId', 'valid')
        } else if ((name === 'eChannelType' || name === 'convert-echannel') && value.value === 'urn:hsbc:cmb:gdocs:products:taxonomies:echannelType:API' && formData['newEchannel'] !== false) {
          this.setFieldValidtionState('apiProfileId', 'valid')
        }
        else {
          this.setFieldValidtionState('apiProfileId', 'invalid')
        }
      }

      if (name === 'erpLink') {
        this.setFieldValidtionState('erpLink', 'valid')
      }
      else if (name === 'eChannelType' && value.value !== 'urn:hsbc:cmb:gdocs:products:taxonomies:echannelType:hsbcNet' && value.value !== 'urn:hsbc:cmb:gdocs:products:taxonomies:echannelType:API' &&
        formData['erpLink'] !== '' && formData['erpLink'] !== undefined) {
        this.setFieldValidtionState('erpLink', 'valid')
      } else if (name === 'eChannelType' && value.value === 'urn:hsbc:cmb:gdocs:products:taxonomies:echannelType:hsbcNet' &&
        formData['surAvailable'] !== '' && formData['surAvailable'] === false && formData['surAvailable'] !== undefined) {
        this.setFieldValidtionState('surAvailable', 'valid')
      } else if ((name === 'profileOwner' && value !== '') || name === 'profileOwnerInPack') {
        this.setFieldValidtionState('profileOwner', 'valid')
      } else if (name === 'surAvailable' && value === false) {
        this.setFieldValidtionState('sur', 'valid')
      } else if ((name === 'eChannelType' || name === 'convert-echannel') && value.value === 'urn:hsbc:cmb:gdocs:products:taxonomies:echannelType:API') {
        this.removeInvalidField('erpLink')

      }
      else if (name === 'surAvailable' && value === true) {
        delete formData['sur']
        this.setFieldValidtionState('sur', 'invalid') // added to make empty sur field value invalid after surAvailable is set to true (Yes) from false (No)
      } else if (name === 'preAllocated' && value === false) {
        this.setFieldValidtionState('accountNumber', 'valid');
        this.setFieldValidtionState('branchCode', 'valid');
        formData['accountNumber'] = '';
        formData['branchCode'] = '';
      } else if (name === 'preAllocated' && value === true) {
        this.setFieldValidtionState('accountNumber', 'invalid');
        this.setFieldValidtionState('branchCode', 'invalid');
      } else if (name === 'bankName' && this.props.properties.editType === 'create-new-cashcon-other-account') {
        formData['otherBankName'] = ''
        formData['addressLine1'] = ''
        formData['addressLine2'] = ''
        formData['addressLine3'] = ''
        formData['city'] = ''
        formData['state'] = ''
        formData['postCode'] = ''
        formData['accountNumber'] = ''
        formData['branchCode'] = ''
        formData['currency'] = ''
        value.value === "other" ? this.setFieldValidtionState('otherBankName', 'invalid') : '';
        this.setFieldValidtionState('addressLine1', 'invalid');
        this.setFieldValidtionState('city', 'invalid');
        if (value.value === "HSBC" || value.value === "hsbc") {
          this.setFieldValidtionState('otherBankName', 'valid');
          this.setFieldValidtionState('addressLine1', 'valid');
          this.setFieldValidtionState('city', 'valid');
        }
        // } else if(name==='bankName' && value.value === 'Other' && this.props.properties.editType === 'create-new-cashcon-other-account'){
        //   formData['otherBankName'] = ''
        //   formData['addressLine1'] = ''
        //   formData['addressLine2'] = ''
        //   formData['addressLine3'] = ''
        //   formData['city'] = ''
        //   formData['state'] = ''
        //   formData['postCode'] = ''
        //   this.setFieldValidtionState('otherBankName','invalid');
        //   this.setFieldValidtionState('addressLine1','invalid');
        //   this.setFieldValidtionState('city','invalid');
        // if('otherBankName' in formData){
        //   if(formData.otherBankName !== ''){
        //     this.setFieldValidtionState('otherBankName','valid');
        //   } else {
        //     this.setFieldValidtionState('otherBankName','invalid');
        //   }
        // }else {
        //   this.setFieldValidtionState('otherBankName','invalid');
        // }if('addressLine1' in formData){
        //   if(formData.addressLine1 !== ''){
        //     this.setFieldValidtionState('addressLine1','valid');
        //   } else {
        //     this.setFieldValidtionState('addressLine1','invalid');
        //   }
        // }else {
        //   this.setFieldValidtionState('addressLine1','invalid');
        // }if('city' in formData){
        //   if(formData.city !== ''){
        //     this.setFieldValidtionState('city','valid');
        //   } else {
        //     this.setFieldValidtionState('city','invalid');
        //   }
        // }else {
        //   this.setFieldValidtionState('city','invalid');
        // }
      } else if (name === 'chequeBookTypes' && value.value === '') {
        formData['chequeBookTypes'] = { name: '', value: '' }
      } else if (name === 'chequeBookTypes' && value.value === 'Standard') {
        formData['numberOfChequeBooks'] = formData['numberOfChequeBooks']
      } else if (name === 'chequeBookTypes' && (value.value === 'Not Required' || value.value === 'Custom')) {
        delete formData['numberOfChequeBooks']
      } else if (name === 'numberOfPaperStatements' && value.value !== '' && value.value !== '') {
        formData['numberOfPaperStatements'] = { name: value.name, value: value.value }
      } else if (name === 'paperStatementFrequency' && value.value !== 'NR' && formData['numberOfPaperStatements'] !== undefined && this.props.numberOfPaperStatements.length === 1) {
        let numberOfPaperStatements = this.props.numberOfPaperStatements;
        formData['numberOfPaperStatements'] = numberOfPaperStatements.length === 1 ? numberOfPaperStatements[0] : formData['numberOfPaperStatements']
      } else if (name === 'glcmImplementation' && value === true && document.getElementById('projectNoField')) {
        this.setFieldValidtionState('projectNo', 'invalid')
      } else if (name === "newEchannel" && this.state.formData.newEchannel !== value && typeof this.props.properties.toggleConvertEchannelModal === 'function') {
        this.props.properties.toggleConvertEchannelModal(value)
        formData[name] = !value
      }

      return { formData };
    }, () => {
      applyFormFieldRules(this.state.formData, name, value, this.props.fieldPrefix, this.props.sow);
      this.validateForm();
      if (!document.getElementById('projectNoField')) {
        if (this.state.formData.glcmImplementation === true) {
          if (this.state.formData.csProjectNumber === undefined || this.state.formData.csProjectNumber === "") {
            this.setFieldValidtionState('csProjectNumber', 'invalid');
          } else if (this.state.formData.csProjectNumber !== undefined && this.state.formData.csProjectNumber.length < 10) {
            this.setFieldValidtionState('csProjectNumber', 'invalid');
          } else {
            this.setFieldValidtionState('csProjectNumber', 'valid');
          }
        }
      } else {
        if (this.state.formData.glcmImplementation === true && this.state.formData.projectNo === 'CS') {
          this.setFieldValidtionState('cmpProjectID', 'valid');
          if (this.state.formData.csProjectNumber === undefined || this.state.formData.csProjectNumber === "") {
            this.setFieldValidtionState('csProjectNumber', 'invalid');
          } else if (this.state.formData.csProjectNumber !== undefined && this.state.formData.csProjectNumber.length < 10) {
            this.setFieldValidtionState('csProjectNumber', 'invalid');
          } else {
            this.setFieldValidtionState('csProjectNumber', 'valid');
          }
        }
        if (this.state.formData.glcmImplementation === true && this.state.formData.projectNo === 'CMP') {
          this.setFieldValidtionState('csProjectNumber', 'valid');
          if (this.state.formData.cmpProjectID === undefined || this.state.formData.cmpProjectID === "") {
            this.setFieldValidtionState('cmpProjectID', 'invalid');
          } else if (this.state.formData.cmpProjectID !== undefined && this.state.formData.cmpProjectID.length < 9) {
            this.setFieldValidtionState('cmpProjectID', 'invalid');
          } else {
            this.setFieldValidtionState('cmpProjectID', 'valid');
          }
        }
      }
      // DGT-10418: Residency is set programmatically on a resident-only country change, so it never passes through Radiobtn.showField to clear its validation state.
      if (name === 'country' && this.state.formData['residency'] === true) {
        this.setFieldValidtionState('residency', 'valid');
      }
      this.props.getFormData(this.state.formData);
    });

  }
  setFieldValidtionState = (fieldName, fieldValidtionState) => {
    var formInvalid = true;
    if (fieldValidtionState === "invalid") {
      this.addInvalidField(fieldName);
      formInvalid = true;
    } else if (fieldValidtionState === "valid") {
      this.removeInvalidField(fieldName);
      formInvalid = this.inValidFields.length === 0 ? false : true;
    }
    this.setState({ formInvalid })
  }

  formRefResolved = (ref) => {
    if (ref) {
      // applying bulk rules
      applyFormFieldBulkRules(this.props.properties, this.state.formData);
      // apply formFieldsVisibilityRules
      Object.keys(this.state.formData).forEach(name => {
        applyFormFieldRules(this.state.formData, name, this.state.formData[name], this.props.fieldPrefix, this.props.sow);
      });
    } else {
    }
  }
  validateField = (achCredit) => {
    let checkUK = []
    achCredit.map(item => {
      if (item.name.indexOf(ACH_UK) !== -1) {
        item.associations.map(check => {
          if (check.isChecked === true) {
            checkUK.push(check)
          }
        })
      }
    })
    return checkUK
  }

  generateInputBoxJsx = ({ title, name, mandatory, minChars, maxChars, isDisabled, isVisible, mandatoryMessage, regex, regexValidationMessage, helpText, suffixSign, tooltipText, placeholderText, prefix = '' }, elementKey) => {
    if (this.props.mode === 'edit' && isDisabled === "true") {
      isDisabled = true;
    }
    //For View profile scenerio

    if (typeof this.props.currentCustomerDetailsEntityId === 'undefined' && this.props.oldEntities.length === 0 && this.props.newEntities.length === 0) {
      if (name === 'registeredName' && this.props.mode === 'edit' && this.props.admin) {
        isDisabled = false;
      }
    }
    if (typeof this.props.oldEntities !== 'undefined' && this.props.oldEntities.length > 0) {
      if ((this.props.oldEntities.indexOf(this.props.currentCustomerDetailsEntityId) > -1) && name === 'registeredName' && this.props.mode === 'edit' && this.props.admin) {
        isDisabled = false;
      }
      else if ((this.props.oldEntities.indexOf(this.props.currentCustomerDetailsEntityId) > -1) && name === 'registeredName' && this.props.mode === 'edit' && (!this.props.admin || this.props.customer !== undefined && this.props.customer.roleDetails.customer)) {
        isDisabled = true;
      }
    }
    if (typeof this.props.newEntities !== 'undefined' && this.props.newEntities.length > 0) {
      if ((this.props.newEntities.indexOf(this.props.currentCustomerDetailsEntityId) > -1) && name === 'registeredName' && this.props.mode === 'edit') {
        isDisabled = false;
      }
    }
    if (typeof this.props.newEntities !== 'undefined' && this.props.newEntities.length > 0) {
      if ((this.props.newEntities.indexOf(this.props.currentCustomerDetailsEntityId) > -1) && name === 'registeredName' && this.props.mode === 'edit') {
        isDisabled = false;
      }
    }

    if (this.props.properties.editType === 'create-new-cashcon-other-account' && (name !== 'otherBankName' && name !== 'entityNameOther') && this.props.mode === 'edit') {
      this.props.history.location.state.key === "subAccount" && (this.props.properties.formData.bankName.value !== "hsbc" && this.props.properties.formData.bankName.value !== "HSBC") ? isVisible = "true" : '';
    }

    if (this.props.properties.editType === 'create-new-cashcon-other-account' && (name !== 'otherBankName' && name !== 'entityNameOther') && this.props.mode === 'edit') {
      this.props.history.location.state.key === "subAccount" && (this.props.properties.formData.bankName.value !== "hsbc" && this.props.properties.formData.bankName.value !== "HSBC") ? isVisible = "true" : '';
    }

    if ((name === 'corpStatus' && this.props.mode === 'edit' && this.props.customer !== undefined && this.props.customer.roleDetails.customer && document.getElementById('corpStatusField') !== null)) {
      document.getElementById(this.getFieldId('corpStatus')).classList.add('noDisplay');
    }
    if (this.props.customer !== undefined && this.props.customer.roleDetails.customer === true && document.getElementById('glcmImplementationField') !== null) {
      document.getElementById(this.getFieldId('glcmImplementation')).classList.add('noDisplay');
    }

    if (this.props.properties.editType === "add-ach-to-case") {
      const { achCredit } = this.state.formData;
      if (achCredit && !isEmpty(achCredit)) {
        let isUKCheck = this.validateField(achCredit)
        if (!isEmpty(isUKCheck)) {
          isVisible = true
        } else {
          isVisible = 'false'
        }
      }
      else {
        isVisible = 'false'
      }
    }

    if ((name === 'csProjectNumber' && this.props.customer.roleDetails.customer === true && document.getElementById('csProjectNumberField') !== null)) {
      document.getElementById(this.getFieldId('csProjectNumber')).classList.add('noDisplay');
    }
    if ((name === 'csProjectNumber')) {
      isVisible = 'false'
    }
    if ((name === 'cmpProjectID' && this.props.customer.roleDetails.customer === true && document.getElementById('cmpProjectIDField') !== null)) {
      document.getElementById(this.getFieldId('cmpProjectID')).classList.add('noDisplay');
    }
    if ((name === 'cmpProjectID')) {
      isDisabled = this.props.formDisabled
      isVisible = 'false'
    }
    if (this.props.sow && name === 'salesManagerName' && this.props.isvisible) {
      isVisible = 'false'
    }
    if (this.props.sow && name === 'salesManagerEmail' && this.props.isvisible) {
      isVisible = 'false'
    }
    if (this.props.sow && name === 'globalSalesManagerName' && this.props.isvisible) {
      isVisible = 'false'
    }
    if (this.props.sow && name === 'globalSalesManagerEmail' && this.props.isvisible) {
      isVisible = 'false'
    }
    if (this.props.properties.editType === "product-requests-form" && name === 'otherProductValue') {
      isVisible = 'false'
    }
    if (this.props.properties.editType === "product-requests-form" && name === 'otherCountryValue') {
      isVisible = 'false'
    }
    if (this.props.customer !== undefined) {
      if (name === 'txtGRIDno' && !this.props.customer.roleDetails.customer) {
        isDisabled = false;
      }
      if (name === 'csProjectNumber' && this.props.customer.roleDetails.customer) {
        isVisible = 'false'
      }
      if (name === 'cmpProjectID' && this.props.customer.roleDetails.customer) {
        isVisible = 'false'
      }
      else if (name === 'annualDate' && this.props.customer.roleDetails.customer) {
        isDisabled = false;
      }//
      //CCR Interest
      else if (name === 'openingLoanPosition' && this.props.customer.roleDetails.customer && this.props.mode === 'edit') {
        isDisabled = true;
      }
      else if (name === 'openingAccuredInterest' && this.props.customer.roleDetails.customer && this.props.mode === 'edit') {
        isDisabled = true;
      }
      else if (name === 'baseRateCode' && this.props.customer.roleDetails.customer && this.props.mode === 'edit') {
        isDisabled = true;
      }
      else if (name === 'spread' && this.props.customer.roleDetails.customer && this.props.mode === 'edit') {
        isDisabled = true;
      }
      else if (name === 'csrAppliedInterestEarnings' && this.props.customer.roleDetails.customer && this.props.mode === 'edit') {
        isDisabled = true;
      }
      else if (name === 'csrAppliedInterestCharges' && this.props.customer.roleDetails.customer && this.props.mode === 'edit') {
        isDisabled = true;
      }
      //Standard Sweep Instructions
      else if (name === 'fundAmount' && this.props.customer.roleDetails.customer) {
        isDisabled = true;
      }
      //CCR Bilateral Limits
      else if (name === 'currency' && this.props.customer.roleDetails.customer) {
        isDisabled = true;
      }
      // Account Interest and Limits
      else if (name === 'odLimit' && this.props.customer.roleDetails.customer) {
        isDisabled = true;
      }
      else if (name === 'borrowingLimit' && this.props.customer.roleDetails.customer) {
        isDisabled = true;
      }
      else if (name === 'registeredName' && this.props.sow && this.isReadOnly()) {
        isDisabled = true;
      }
      else if (name === 'fundAmount' && this.props.sow && this.isReadOnly()) {
        isDisabled = true;
      }
      else if (name === 'openingLoanPosition' && this.props.sow && this.isReadOnly()) {
        isDisabled = true;
      }
      else if (name === 'openingAccuredInterest' && this.props.sow && this.isReadOnly()) {
        isDisabled = true;
      }
      else if (name === 'csrAppliedInterestCharges' && this.props.sow && this.isReadOnly()) {
        isDisabled = true;
      }
      else if (name === 'csrAppliedInterestEarnings' && this.props.sow && this.isReadOnly()) {
        isDisabled = true;
      }
      else if (name === 'salesManagerName' && this.props.sow && this.isReadOnly()) {
        isDisabled = true;
      }
      else if (name === 'salesManagerEmail' && this.props.sow && this.isReadOnly()) {
        isDisabled = true;
      }
      else if (name === 'globalSalesManagerName' && this.props.sow && this.isReadOnly()) {
        isDisabled = true;
      }
      else if (name === 'globalSalesManagerEmail' && this.props.sow && this.isReadOnly()) {
        isDisabled = true;
      }
    }
    else {
      isDisabled = false;
    }
    var checkAvailabilityProps;
    var SearchProps;
    let msaCasesProps = { jsx: null, isMsaCase: false }
    if (this.state.formSchema.guideContainer.rootPanel.items.guidecheckbox_2011cases) {
      msaCasesProps = {
        jsx: this.generateCheckBoxJsx(this.state.formSchema.guideContainer.rootPanel.items.guidecheckbox_2011cases, this.props.msaCases, this.props.handleMsaCases)
        , isMsaCase: this.props.msaCases, regexPatternMsaCase: `^(0[1-9]|[1-2][0-9]|31(?!(?:0[2469]|11))|30(?!02))(0[1-9]|1[0-2])([12]\\d{3})-[0-9]{5}(;[0-9]{5})*$`
      }
    }

    if (this.props.properties.editType === "add-manual-case-basic-details") {
      if (name === "txtGRIDno" || name === "registeredName") {
        isDisabled = this.props.formDisabled;
      }
      if (name === "txtGRIDno") {
        isDisabled = this.props.formDisabled;
        this.props.msaCases ? isVisible = 'false' : isVisible = 'true';
      }
      if (name === "CaseID") {
        checkAvailabilityProps = this.state.formSchema.guideContainer.rootPanel.items.guidebutton_CheckAvailability;
        SearchProps = this.state.formSchema.guideContainer.rootPanel.items.guidebutton_Search;
        regex = '^(0[1-9]|[1-2][0-9]|31(?!(?:0[2469]|11))|30(?!02))(0[1-9]|1[0-2])([12]\\d{3})-[0-9]{5}(;[0-9]{5})*$';
        isDisabled = true
      }
    }

    if (this.props.properties !== undefined && this.props.properties.editType === "add-manual-case-documentation-details" && name === "createdBy") {
      if (this.props.properties.formData[name] !== undefined || this.props.properties[name])
        this.removeInvalidField(name);
    }

    if (this.props.properties !== undefined && this.props.properties.editType === "add-manual-case-documentation-details" && name === "RAF") {
      if ((this.props.properties.formData[name] !== undefined && this.props.properties.formData[name] !== "") || this.props.properties[name] || (this.state.formData[name] !== undefined && this.state.formData[name] !== "")) {
        isVisible = "true";
        isDisabled = true;
      } else {
        isVisible = "false";
      }
    }

    if (this.props.productType === "activate-cashFlowForecasting") {
      if ("isTheProductLive" in this.state.formData) {
        isDisabled = false
      } else {
        isDisabled = true
      }
    }

    if (this.props.navigatedFrom === 'gls-np-interest-optimization' || this.props.navigatedFrom === 'gls-ie-detailed-settings') {
      isDisabled = this.isReadOnly()
    }

    if (name === "internalAccountNumber" && this.props.properties && this.props.properties.accountNumber) {
      if (this.props.properties.formData && !this.props.properties.formData[name] && this.props.properties.formData[name] !== '') {
        this.setFormElementData(this.props.properties.accountNumber, name)
      }
      if (this.isReadOnly()) {
        isDisabled = true
      }
    }

    if (this.checkGLSNPIOPoolAccount('pool') && (name === 'internalAccountNumber' || name === 'extAccountNumber' || name === 'iban')) {
      isVisible = 'false'
    }

    if (name === 'other' && this.state.formData.title && this.state.formData.title.value) {
      if (this.state.formData.title.value === "other") {
        isVisible = 'true'
      } else {
        isVisible = 'false'
      }
    }
    if (name === 'apiProfileId' && this.state.formData['eChannelType'] && this.state.formData['eChannelType'].value === 'urn:hsbc:cmb:gdocs:products:taxonomies:echannelType:API' && this.state.formData['newEchannel'] === false) {
      isVisible = 'true'
    }

    // const disabled = (this.props.mode === 'edit' && isDisabled === "true") ? true : false;
    const visibilityCss = classnames("form-group row", {
      noDisplay: isVisible === 'false'
    });
    let TranslatedPlaceholdertext = Translations(placeholderText, this.props.lang, this.props.translatedData)
    const _jsx = (
      <div key={elementKey} className={visibilityCss} id={`${this.props.fieldPrefix || ""}${name}Field${this.props.italyIndex !== undefined ? this.props.italyIndex : ''}`}>
        <label for={name + this.state.randomIdx} className="col-lg-4">{Translations(title, this.props.lang, this.props.translatedData)}</label>
        <div className="col-lg-8 col-sm-12">
          <InputText name={name}
            id={name + this.state.randomIdx}
            mandatory={mandatory}
            properties={this.props.properties}
            min={minChars}
            max={maxChars}
            flag={this.state.flag}
            flagCheck={this.props.flagCheck}
            CaseRecordToggle={this.props.CaseRecordToggle}
            CreateNewToggle={this.props.CreateNewToggle}
            ResetForm={this.props.ResetForm}
            resetData={this.props.resetData}
            disabled={isDisabled}
            mandatoryMessage={mandatoryMessage}
            regexPattern={regex}
            CheckAvailabilityProps={checkAvailabilityProps}
            SearchProps={SearchProps}
            regexValidationMessage={regexValidationMessage}
            helpText={helpText}
            displayError={name === "CaseID" ? this.props.displayError : undefined}
            tooltipText={tooltipText}
            suffixSign={suffixSign}
            _value={this.props.properties.formData[name] || this.props.properties[name] || this.state.formData[name]}
            setInputvalue={this.setFormElementData}
            setFieldValidtionState={this.setFieldValidtionState}
            fieldPrefix={this.props.fieldPrefix}
            setSelectedOptions={this.props.setSelectedOptions}
            onCheckAvailability={this.props.onCheckAvailability}
            onSearch={this.props.onSearch}
            lang={this.props.lang}
            setEchanelBtn={this.props.setEchanelBtn}
            setAccountBtnOnCancel={this.props.setAccountBtnOnCancel}
            translatedData={this.props.translatedData}
            placeholder={TranslatedPlaceholdertext}
            msaCasesProps={msaCasesProps}
            inputPrefix={Translations(prefix, this.props.lang, this.props.translatedData)}
          />
        </div>
      </div>
    );

    return _jsx;
  }

  generateCheckBoxJsx = (props = {}, isChecked = false, onChange) => {
    const { name, title, disabled, isVisible } = props
    const label = Translations(title, this.props.lang, this.props.translatedData)
    if (isVisible) {
      return <div className='gdocs-dynamic-generate-checkBox'>
        <Checkbox
          name={"manual_case-msa_" + label}
          id={"manual_case-msa_" + label}
          controlled
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled === "true" ? true : false}
          // readOnly={isChecked}
          lblText={label}
          checked={isChecked}
        ></Checkbox>
        <label htmlFor={label}>{label}</label>
      </div>
    }
    else {
      return null
    }
  }

  generatePasswordJsx = ({ title, name, mandatory, minChars, maxChars, isDisabled, isVisible, mandatoryMessage, regex, regexValidationMessage }, elementKey) => {
    const disabled = (isDisabled === "true") ? true : false;
    const visibilityCss = classnames("form-group row", {
      noDisplay: isVisible === 'false'
    });
    const _jsx = (
      <div key={elementKey} className={visibilityCss} id={`${this.props.fieldPrefix || ""}${name}Field`}>
        <label for={name} className="col-lg-4" id={name + this.state.randomIdx}>{Translations(title, this.props.lang, this.props.translatedData)}</label>
        <div className="col-lg-8 col-sm-12">
          <Password name={name}
            mandatory={mandatory}
            min={minChars}
            max={maxChars}
            disabled={disabled}
            regexPattern={regex}
            regexValidationMessage={regexValidationMessage}
            mandatoryMessage={mandatoryMessage}
            _value={this.props.properties.formData[name] || this.props.properties[name]}
            setInputvalue={this.setFormElementData}
            setFieldValidtionState={this.setFieldValidtionState}
            lang={this.props.lang}
            translatedData={this.props.translatedData}
            fieldPrefix={this.props.fieldPrefix} />
        </div>
      </div>
    );

    return _jsx;
  }

  generateDatePickerJsx = ({ title, name, mandatory, mandatoryMessage, isVisible }, elementKey) => {
    const visibilityCss = classnames('form-group row', { noDisplay: isVisible === 'false' });
    const dateSelectorCSSClasses = classnames(
      'col-lg-8',
      'col-sm-12',
      {
        disabled: this.props.formDisabled,
      }
    );
    const _jsx = (
      <div key={elementKey} className={visibilityCss} id={`${this.props.fieldPrefix || ""}${name}Field${this.props.italyIndex !== undefined ? this.props.italyIndex : ''}`}>
        <label className="col-lg-4" id={name}>{Translations(title, this.props.lang, this.props.translatedData)}</label>
        <div className={dateSelectorCSSClasses}>
          <DateSelector inputTypeAttr="text"
            inputPlaceholderAttr='Enter date'
            properties={this.props.properties}
            onDateSelected={this.logAction('onDateSelected')}
            extendedPanel={true}
            dateRangeOptions={[]}
            showIcon={true}
            name={name}
            value={this.props.properties.formData[name]}
            setdatepicker={this.setFormElementData}
            setFieldValidtionState={this.setFieldValidtionState}
            fieldPrefix={this.props.fieldPrefix}
            readOnly={this.props.formDisabled}
          />
        </div>
      </div>
    );

    return _jsx;
  }

  generateRadioButtonJsx = ({ title, options, name, mandatory, mandatoryMessage, isVisible, isDisabled, disabled }, elementKey) => {
    let visibilityCssFormargin = ''
    if (name === 'marginApplicable' && this.props.customer !== undefined && this.props.customer.roleDetails.customer) {
      isVisible = 'false'
      visibilityCssFormargin = classnames({
        noDisplay: isVisible === 'false'
      });
    }
    let visibilityCss = classnames("form-group row", {
      noDisplay: isVisible === 'false'
    });
    if (this.props.sow && this.isReadOnly()) {
      isDisabled = true
    }

    if (name === 'erpLink' && this.state.formData['eChannelType'] && this.state.formData['eChannelType'].value === 'urn:hsbc:cmb:gdocs:products:taxonomies:echannelType:API') {

      visibilityCssFormargin = classnames("form-group row", {
        noDisplay: true
      });

    }

    const ccrFormCondition = {
      interestChargesTierStatus: "interestCharges.interestRateType",
      interestEarnTierStatus: "interestEarnings.interestRateType",
    }
    if (ccrFormCondition[name]) {
      Object.keys(ccrFormCondition).map(key => {
        if (this.state.formData[key] === undefined) {
          this.updateFormState({ [key]: "notiering" })
        }
      })
    }

    if (name === "gleNeedsRates") {
      if (this.state.formData[name] && this.state.formData[name] === true) {
        if (this.state.formData.accountDebitTierStatus === undefined || this.state.formData.accountCreditTierStatus === undefined) {
          this.updateFormState({ accountDebitTierStatus: "notiering", accountCreditTierStatus: "notiering" })
        } else {

        }
      }
      else if (this.state.formData[name] !== undefined && this.state.formData[name] === false) {
        if (this.state.formData.accountDebitTierStatus !== undefined || this.state.formData.accountCreditTierStatus !== undefined) {
          this.updateFormState({
            accountDebitTierStatus: undefined, accountCreditTierStatus: undefined,
            accountInterestCreditTiers: [], accountInterestDebitTiers: [], tiersCredit: [], tiersDebit: [], credit: { interestRateType: "baseRate" },
            debit: { interestRateType: "baseRate" }
          })
        }
      }
    }

    const _jsx = (
      <div key={elementKey} className={visibilityCss} id={`${this.props.fieldPrefix || ""}${name}Field${this.props.italyIndex !== undefined ? this.props.italyIndex : ''}`}>
        <label className={`col-lg-4 ${visibilityCssFormargin}`} id={name + this.state.randomIdx}>{Translations(title, this.props.lang, this.props.translatedData)}</label>
        <div className="col-lg-8 col-sm-12 gdocs-dynamic-radiogroup-wrapper" role="radiogroup" aria-labelledby={name + this.state.randomIdx}>
          <div>{this.getRadioOptions(options, name, mandatory, mandatoryMessage, isDisabled ? isDisabled : disabled)}</div>
          <div>{this.generateResetButtonJsx({ name })}</div>
        </div>
      </div>
    );

    return _jsx;
  }

  generateResetButtonJsx = ({ name }) => {
    const resetProps = this.state.formSchema.guideContainer.rootPanel.items.guidebutton_Reset;
    const resetBtnProps = {
      translatedText: resetProps ? Translations(resetProps.text, this.props.lang, this.props.translatedData) : '',
      bsClass: "gdocs-btn-Reset",
      id: "manual-case-reset-button"
    }

    return name === "CaseRecordType" ?
      <div key="buttons-wrapper" className="reset-buttons-wrapper">
        <FormButton {...resetBtnProps} key={"Reset"} _onClick={this.props.onReset} />
      </div>
      : ''
  }

  validData = (arr, setValidationFlag) => {
    var formInvalid = true;
    if (setValidationFlag === 'true' && this.props.mode !== "edit") {
      this.inValidFields = [];
      this.setState({ formData: {} })
    }

    if (arr.length > 0 && setValidationFlag === 'false') {
      arr.forEach((currentValue, index) => {
        if (currentValue in this.state.formData) {
          if (this.state.formData['newEchannel'] === false) {
            if (this.state.formData['otherProfileOwner'] !== undefined && this.state.formData['otherProfileOwner'] === '') {
              //this.inValidFields.push(currentValue);
            } else if (this.state.formData['otherProfileOwner'] !== undefined && this.state.formData['otherProfileOwner'] !== '') {
              this.inValidFields.remove('profileOwnerInPack');
              this.inValidFields.remove('profileOwner');
            } else {
              this.inValidFields.remove(currentValue);
            }
          } else if (this.state.formData['newEchannel'] === true && currentValue === 'erpLink') {
            // remove HSBCnet specific fields from validation for other E-Channels - all of which have erpLink
            this.inValidFields.remove('surAvailable');
            this.inValidFields.remove('sur');
            this.inValidFields.remove('singleSignOn');
            this.inValidFields.remove('ipWhitelisting');
            if (this.inValidFields.indexOf(currentValue) === -1) {
              this.inValidFields.push(currentValue);
            }
          } else if (this.state.formData['newEchannel'] === true && currentValue === 'surAvailable') {
            this.inValidFields.remove('erpLink');
            if (this.state.formData['surAvailable'] === undefined && this.inValidFields.indexOf(currentValue) === -1) {
              this.inValidFields.push(currentValue);
            } else {
              if (this.state.formData['surAvailable'] === true && this.state.formData['sur'] === undefined && this.inValidFields.indexOf(currentValue) === -1) {
                this.inValidFields.push('sur');
              }
            }
          } else if (this.state.formData['newEchannel'] === true && currentValue === 'singleSignOn') {
            if (this.state.formData['singleSignOn'] === undefined && this.inValidFields.indexOf(currentValue) === -1) {
              this.inValidFields.push(currentValue);
            }
          } else if (this.state.formData['newEchannel'] === true && currentValue === 'ipWhitelisting') {
            if (this.state.formData['ipWhitelisting'] === undefined && this.inValidFields.indexOf(currentValue) === -1) {
              this.inValidFields.push(currentValue);
            }
          }
        }
        else {
          if (this.state.formData['newEchannel'] === false && this.state.formData['profileOwnerInPack'] === undefined &&
            currentValue !== 'surAvailable' && currentValue !== 'erpLink' && currentValue !== 'otherProfileOwner' &&
            currentValue !== 'singleSignOn' && currentValue !== 'ipWhitelisting') {
            if (this.inValidFields.indexOf(currentValue) === -1) {
              this.inValidFields.push(currentValue);
            }
          } else if (this.state.formData['newEchannel'] === false &&
            currentValue === 'otherProfileOwner') {
            this.inValidFields.remove('profileOwner');
            if (this.inValidFields.indexOf(currentValue) === -1) {
              //this.inValidFields.push(currentValue);
            }
          } else if (this.state.formData['newEchannel'] === false &&
            currentValue === 'profileOwner') {
            this.inValidFields.remove('otherProfileOwner');
            this.inValidFields.remove('profileOwnerInPack');
          } else if (this.state.formData['newEchannel'] === false &&
            (currentValue === 'surAvailable' || currentValue === 'singleSignOn' || currentValue === 'ipWhitelisting')) {
            this.inValidFields.remove(currentValue);
          } else if (this.state.formData['newEchannel'] === false &&
            currentValue === 'erpLink') {
            this.inValidFields.remove(currentValue);
          } else if (this.state.formData['newEchannel'] === true &&
            (currentValue === 'surAvailable' || currentValue === 'singleSignOn' || currentValue === 'ipWhitelisting')) {
            if (this.inValidFields.indexOf(currentValue) === -1) {
              this.inValidFields.push(currentValue);
            }
            this.inValidFields.remove('erpLink');
          } else if (this.state.formData['newEchannel'] === true &&
            currentValue === 'erpLink') {
            if (this.inValidFields.indexOf(currentValue) === -1) {
              this.inValidFields.push(currentValue);
            }
            this.inValidFields.remove('surAvailable')
            this.inValidFields.remove('sur')
            this.inValidFields.remove('singleSignOn');
            this.inValidFields.remove('ipWhitelisting');
          }
          else {
            this.inValidFields.push(currentValue);
          }
        }

      });

    } else {
      this.inValidFields = arr;
    }
    if (this.inValidFields !== undefined) {
      formInvalid = this.inValidFields.length === 0 ? false : true;
    } else {
      formInvalid = arr.length === 0 ? false : true;
    }
    this.setState({ formInvalid })
  }
  convertStringToArrayForRadioBtn = (str) => {
    var array = []
    if (str !== undefined && str !== '') {
      var str1 = str.split('"')[3];
      var str2 = str.split('"')[7];
      var str3 = str.split('"')[11];
      array.push(str1);
      array.push(str2);
      array.push(str3);
      return array;
    }
  }
  getRadioOptions = (options, name, mandatory, mandatoryMessage, isDisabled, isVisible) => {
    let disabled = false;
    let _value = this.state.formData[name];
    if (this.props.mode === "edit") {
      disabled = isDisabled;
      if (name === 'tiering') {
        _value = this.state.formData[name] || false;
      }
      if (name === 'gross') {
        _value = this.state.formData[name] || "na";
      }

      // if(typeof this.props.newEntities !== 'undefined' && this.props.newEntities.length > 0 && typeof this.props.currentCustomerDetailsEntityId !== 'undefined'){
      //   if((this.props.newEntities.indexOf(this.props.currentCustomerDetailsEntityId) === -1) && name === 'financialInstitution'){
      //     _value = '';
      //   }
      // }
      // In financialInstitution HO(Admin, CI user) can edit only
      if (name === 'financialInstitution' && this.props.customer !== undefined && !this.props.customer.roleDetails.customer) {
        disabled = false
      }
      if (name === 'marginApplicable' && this.props.customer !== undefined && this.props.customer.roleDetails.customer) {
        isVisible = 'false'
      }
      if (name === 'glcmImplementation' && this.props.customer !== undefined && this.props.customer.roleDetails.customer) {
        isVisible = 'false'
      }
      else if (name === 'financialInstitution' && this.props.customer !== undefined && this.props.customer.roleDetails.customer) {
        disabled = true
      }
      else if (name === 'specificFundRequest' && this.props.customer !== undefined && this.props.customer.roleDetails.customer) {
        disabled = true
      }
      //CCR Interest
      else if (name === 'interestEarnings-interestRateType' && this.props.customer !== undefined && this.props.customer.roleDetails.customer) {
        disabled = true
      }
      else if (name === 'interestEarnings-rate' && this.props.customer !== undefined && this.props.customer.roleDetails.customer) {
        disabled = true
      }
      else if (name === 'tiering' && this.props.customer !== undefined && this.props.customer.roleDetails.customer) {
        disabled = true
      }
      else if (name === 'gross' && this.props.customer !== undefined && this.props.customer.roleDetails.customer) {
        disabled = true
      }
      else if (name === 'unauthorizedInterestType' && this.props.customer !== undefined && this.props.customer.roleDetails.customer) {
        disabled = true
      }
      //Account Interest and Limits
      else if (name === 'sweepGroups' && this.props.customer !== undefined && this.props.customer.roleDetails.customer) {
        disabled = true
      }
      else if (name === 'accountLimit' && this.props.customer !== undefined && this.props.customer.roleDetails.customer) {
        disabled = true
      }
      else if (name === 'accountLimit' && this.props.properties.formData.accountLimit !== undefined) {
        disabled = true
      }
    }

    // DGT-10418: Lock the residency radiogroup once resident is selected for a resident-only country.
    // Left enabled while non-resident is selected so the user can still switch back to resident.
    if (name === 'residency' && this.isResidentOnlyAccountCountry() && this.getSelectedResidency() === true) {
      disabled = true;
    }

    var currentWord = Translations(options, this.props.lang, this.props.translatedData)
    var convertedArray = convertStringToArrayForRadio(currentWord);
    if (this.props.properties.editType === "product-requests-form") {
      if (name === "csResidency") {
        convertedArray = this.convertStringToArrayForRadioBtn(currentWord);
      }
    }

    if (Array.isArray(convertedArray)) {
      return convertedArray.map((option, index) => {
        var splitOption = option.split('=');
        if (splitOption[0] === "reduxOption" && name !== 'otherAccountHolder') {
          splitOption = this.getOptionFromRedux(splitOption[1]);
          _value = (_value === undefined || _value === "") ? splitOption[0] : _value;
        }
        const value = splitOption[0];
        const optionText = splitOption[1];
        let visibilityCss = classnames("radiobtn", {
          noDisplay: isVisible === 'false'
        });
        if (name === 'erpLink' && this.state.formData['eChannelType'] && this.state.formData['eChannelType'].value === 'urn:hsbc:cmb:gdocs:products:taxonomies:echannelType:API') {

          visibilityCss = classnames("form-group row", {
            noDisplay: true
          });

        }

        if (this.props.properties.editType === "add-manual-case-basic-details") {
          disabled = isDisabled;

          if (name === "CaseRecordType") {
            _value = this.props.properties.formData[name]
            this.inValidFields.remove(name);
          }
          if (name === 'projectNo') {
            disabled = this.props.formDisabled;
            this.inValidFields.remove(name);
          }
          /* if (name === 'cmpProjectID') {
            disabled = this.props.formDisabled;
          } */
          if (name === "glcmImplementation" || name === "financialInstitution") {
            disabled = this.props.formDisabled;
            if (this.props.msaCases) {
              if (document.getElementById('glcmImplementationField')) document.getElementById('glcmImplementationField').classList.add('noDisplay');
              if (document.getElementById('financialInstitutionField')) document.getElementById('financialInstitutionField').classList.add('noDisplay');
              if (document.getElementById('csProjectNumberField')) document.getElementById('csProjectNumberField').classList.add('noDisplay');
              if (document.getElementById('cmpProjectIDField')) document.getElementById('cmpProjectIDField').classList.add('noDisplay');
            }
            else {
              if (document.getElementById('glcmImplementationField') !== null && document.getElementById('financialInstitutionField') !== null) {
                document.getElementById('glcmImplementationField').classList.remove('noDisplay');
                document.getElementById('financialInstitutionField').classList.remove('noDisplay');
              }
            }
          }
          if (name === "glcmImplementation") {
            if (!document.getElementById('projectNoField')) {
              this.state.formData[name] === true ?
                this.state.formData["csProjectNumber"] === "" || this.state.formData["csProjectNumber"] === undefined ? this.addInvalidField("csProjectNumber") : ''
                : this.removeInvalidField("csProjectNumber")
            } else {
              this.state.formData[name] === true
                ? this.state.formData.projectNo === "CS" &&
                  (this.state.formData["csProjectNumber"] === "" || this.state.formData["csProjectNumber"] === undefined)
                  ? this.addInvalidField("csProjectNumber")
                  : ''
                : this.removeInvalidField("csProjectNumber")
            }
          }
          if (name === "projectNo") {
            if (this.state.formData[name] === true) {
              this.state.formData.projectNo === "CMP" &&
                (this.state.formData["cmpProjectID"] === "" || this.state.formData["cmpProjectID"] === undefined)
                ? this.addInvalidField("cmpProjectID")
                : ''
            } else {
              this.removeInvalidField("cmpProjectID");
            }
          }
          if (this.props.resetData !== this.state.resetData) {
            this.setState({
              formData: {
                ...this.state.formData,
                glcmImplementation: this.props.properties.formData["glcmImplementation"],
                financialInstitution: this.props.properties.formData["financialInstitution"],
              }
            })
            if (this.props.properties.formData["glcmImplementation"] === true) {
              document.getElementById("csProjectNumberField") !== null ? document.getElementById("csProjectNumberField").classList.remove('noDisplay') : '';
              document.getElementById("cmpProjectIDField") !== null ? document.getElementById("cmpProjectIDField").classList.remove('noDisplay') : '';
            } else {
              document.getElementById("csProjectNumberField") !== null ? document.getElementById("csProjectNumberField").classList.add('noDisplay') : '';
              document.getElementById("cmpProjectIDField") !== null ? document.getElementById("cmpProjectIDField").classList.add('noDisplay') : '';
            }
            _value = this.props.properties.formData[name]
            this.setState({ resetData: this.props.resetData })
          }
          if (this.props.CaseRecordToggle !== this.state.CaseRecordToggle || this.props.CreateNewToggle !== this.state.CreateNewToggle) {
            this.setState({
              formData: {
                ...this.state.formData,
                glcmImplementation: "",
                financialInstitution: ""
              }
            })
            document.getElementById("csProjectNumberField") !== null ? document.getElementById("csProjectNumberField").classList.add('noDisplay') : '';
            document.getElementById("cmpProjectIDField") !== null ? document.getElementById("cmpProjectIDField").classList.add('noDisplay') : '';
            _value = this.props.properties.formData[name]
            this.setState({
              CaseRecordToggle: this.props.CaseRecordToggle,
              CreateNewToggle: this.props.CreateNewToggle
            })
          }
        }
        if (this.props.properties !== undefined && this.props.properties.editType === "add-manual-case-documentation-details") {
          // disabled = isDisabled;
          disabled = this.props.formDisabled;
          if (_value === undefined) {
            _value = this.props.properties.formData[name]
          }
        }

        if (this.props.properties.editType === "convert-echannel" && name === "newEchannel") {
          disabled = true
        }

        if (this.props.properties.editType === "capture-product-echannel-basic-details" && name === "newEchannel" && this.props.customer.roleDetails.customer) {
          disabled = true
        }

        return (
          <div key={index} className={visibilityCss}>
            <Radiobtn name={name}
              id={name + index + this.state.randomIdx}
              disabled={disabled}
              _value={_value}
              value={value}
              _index={this.props.italyIndex}
              editType={this.props.properties.editType}
              mandatory={mandatory}
              resetCaseID={this.props.resetCaseID}
              resetData={this.props.resetData}
              reload={this.props.reload}
              rafValidationPopup={this.props.rafValidationPopup}
              // resetBtnProps={resetBtnProps}
              onReset={this.props.onReset}
              validData={this.validData}
              onSubmit={this.props.onSubmit}
              resetValues={this.props.resetValues}
              validateRAFNumber={this.props.validateRAFNumber}
              entityFromPack={this.props.entityFromPack}
              mode={this.props.mode}
              mandatoryMessage={Translations(mandatoryMessage, this.props.lang, this.props.translatedData)}
              setInputvalue={this.setFormElementData}
              setFieldValidtionState={this.setFieldValidtionState}
              fieldPrefix={this.props.fieldPrefix}
              existingEntityData={this.props.properties.existingEntityData}
              formData={this.state.formData}
              resetEntity={this.props.resetEntity}
              lang={this.props.lang}
              translatedData={this.props.translatedData}
              randomIdx={this.state.randomIdx}
              toggleBankingNonBankingHelpTextModal={this.props.properties.bankingNonBankingHelpTextModal ? () => this.setState({ showBankingNonBankingHelpTextModal: true }) : undefined}
            />
            <label
              className={classnames("gdoc-radio-label", { "disabled": disabled && String(_value) !== value })}
              htmlFor={name + index + this.state.randomIdx}
            >
              {optionText}
            </label>
          </div>
        );
      });
    }
    else {
      return []
    }
  }

  getOptionFromRedux = (optionType) => {
    if (optionType === "currentEntity") {
      const cases = this.props.cases;
      var entityName = cases[this.props.currentProductEchannel.data.caseId].entityName;
      return [entityName, entityName];
    }
  }

  generateNestedCheckBoxJsx = ({ title, name, apiUrl, mandatory, mandatoryMessage, elementKey, helpText }) => {
    const _jsx = (
      <div
        className={'form-group row'}
      >
        <label
          className="col-lg-4"
          htmlFor={name}
        >
          {helpText ?
            <React.Fragment>
              <div>{Translations(title, this.props.lang, this.props.translatedData)}</div>
              <div>{Translations(helpText, this.props.lang, this.props.translatedData)}</div>
            </React.Fragment>
            : Translations(title, this.props.lang, this.props.translatedData)}
        </label>
        <div className="col-lg-8 col-sm-12">
          <NestedCheckBox
            getValues={val => this.getSelectedValue(val)}
            resourceUrl={Translations(apiUrl, this.props.lang, this.props.translatedData)}
            mandatory={mandatory}
            mandatoryMessage={Translations(mandatoryMessage, this.props.lang, this.props.translatedData)}
            setFieldValidtionState={this.setFieldValidtionState}
            name={name}
            achCreditProductList={this.props.achCreditProductList}
            selectedCaseId={this.state.formData['entity'] !== undefined ? this.state.formData.entity.value : ''}
            isAssociation={this.props.isAssociation === undefined ? undefined : this.props.isAssociation}
            productType={this.props.productType}
            productList={this.props.productList}
          />
        </div>
      </div>
    );

    return _jsx;
  }


  handleChange = name => e => {
    this.setFormElementData(e, name);
    // let nowSelectedObject = this.data.filter(item => item.id === e);
    // console.log("Now selecting item: ", e);
    // console.log("Object selected: ", nowSelectedObject);
    // let newFormData = {
    //   ...this.props.properties.formData,
    //   [name]:e
    //   }
    // this.setState({
    //   formData:newFormData,
    //   selectedObject: nowSelectedObject
    // });
  };

  getFieldId = (fieldName) => {
    return this.props.fieldPrefix !== undefined ? `${this.props.fieldPrefix}${fieldName}Field` : `${fieldName}Field`;
  }

  // generateDropDownSelect=({options,name,label,mandatory,mandatoryMessage},elementKey)=>{
  //   //console.log("parsing JSON: ",data.guideContainer.rootPanel.items.dropdownlist_entityACHCreditProduct.options);
  //   console.log("now translating: ",Translations(options,this.props.lang,this.props.translatedData));
  //   let displayKey = options ? JSON.parse(Translations(options,this.props.lang,this.props.translatedData)):[[]];
  //   let _label = label ? Translations(label,this.props.lang,this.props.translatedData) : 'Select a value from the drop down';
  //   console.log(displayKey);
  //   const _jsx = (
  //     <WrappedDropDownSelect
  //       key={elementKey}
  //       name={name}
  //       options={this.data}
  //       optionKey={"id"}
  //       optionDisplayKey={displayKey}
  //       placeHolder="Select from list"
  //       customErrorMessage="Please select value"
  //       selectedValue={this.props.properties.formData[name] || ''}
  //       onSelect={this.handleChange(name)}
  //       editable
  //       required={mandatory?true:false}
  //       label={_label}
  //       linkTo={{ title: "Add other item", link: "www.google.com" }}
  //     />
  //   )
  //   return _jsx;
  // }


  generateDropdownJsx = ({ title, name, apiUrl, dropdownType, options, mandatory, mandatoryMessage, helpText, isVisible, isDisabled, tooltipText, _value, disabled, apiUrlSA }, elementKey) => {
    const visibilityCss = classnames("form-group row", {
      noDisplay: isVisible === 'false'
    });
    if (typeof this.props.oldEntities !== 'undefined' && this.props.oldEntities.length > 0) {
      if ((this.props.oldEntities.indexOf(this.props.currentCustomerDetailsEntityId) > -1) && name === 'countryOfIncorporation' && this.props.mode === 'edit' && this.props.admin) {
        isDisabled = false;
      }

    }
    if (typeof this.props.newEntities !== 'undefined' && this.props.newEntities.length > 0) {
      if ((this.props.newEntities.indexOf(this.props.currentCustomerDetailsEntityId) > -1) && name === 'countryOfIncorporation' && this.props.mode === 'edit') {
        isDisabled = false;
      }

    }
    if ((typeof disabled === "string" && disabled.toLocaleLowerCase() === "true") && this.props.productType === "capture-cash-flow-forecasting-basic-details") {
      isDisabled = disabled
    }
    if (this.props.sow && this.isReadOnly()) {
      isDisabled = true
    }

    const _jsx = (
      <div key={elementKey} className={visibilityCss} id={`${this.props.fieldPrefix || ""}${name}Field${this.props.italyIndex !== undefined ? this.props.italyIndex : ''}`}>
        <label for={name + this.state.randomIdx} className="col-lg-4" htmlFor={name}>{Translations(title, this.props.lang, this.props.translatedData)}</label>
        <div className="col-lg-8 col-sm-12">
          {this.getDropDownOps(name, Translations(apiUrl = this.checkGLSNPIOPoolAccount('stand') ? apiUrlSA : apiUrl, this.props.lang, this.props.translatedData), dropdownType, options, mandatory, mandatoryMessage, helpText, isVisible, isDisabled, tooltipText, Translations(_value, this.props.lang, this.props.translatedData))}
        </div>
      </div>
    );

    return _jsx;
  }
  setLangChangeDropDown = (lang1, lang2, ddname, currLang, type) => {
    if (ddname !== undefined && (type !== 'notionallocation' && type !== 'country' && type !== "paperStatementFrequency" && type !== "numberOfPaperStatements" && type !== "chequeBooksRequired" && type !== "numberOfChequeBooks" && type !== "chequeBookTypes")) {
      let arr = ddname.split(':')
      let lastEle = arr.slice(-1)[0]
      if (lastEle === lang1 || lastEle === lang2) {
        arr.splice(arr.lastIndexOf(lastEle), 1, currLang)
        ddname = arr.join(':');
        return ddname;
      }
      else {
        return ddname;
      }
    }
    else {
      return ddname;
    }
  }
  generateTableOps = (props, key) => {

    if (props !== undefined) {
      let meta = [{
        displayName: convertStringToArray(Translations(props.fieldLabels, this.props.lang, this.props.translatedData))[0],
        key: "caseNumber",
        type: "String",
        defaultValue: "NA"
      }, {
        displayName: convertStringToArray(Translations(props.fieldLabels, this.props.lang, this.props.translatedData))[1],
        key: "outputDocumentType",
        type: "String",
        defaultValue: "NA"
      }, {
        displayName: convertStringToArray(Translations(props.fieldLabels, this.props.lang, this.props.translatedData))[2],
        key: "productType",
        type: "String",
        defaultValue: "NA"
      }, {
        displayName: convertStringToArray(Translations(props.fieldLabels, this.props.lang, this.props.translatedData))[3],
        key: "country",
        type: "String",
        defaultValue: "NA"
      }, {
        displayName: convertStringToArray(Translations(props.fieldLabels, this.props.lang, this.props.translatedData))[4],
        key: "negotiated",
        type: "String",
        defaultValue: "NA"
      }, {
        displayName: convertStringToArray(Translations(props.fieldLabels, this.props.lang, this.props.translatedData))[5],
        key: "caseOwner",
        type: "String",
        defaultValue: "NA"
      }, {
        displayName: convertStringToArray(Translations(props.fieldLabels, this.props.lang, this.props.translatedData))[6],
        key: "caseStatus",
        type: "String",
        defaultValue: "NA"
      }];

      return (
        !this.props.msaCases ?
          <div className="service-history-container">
            <h4>{Translations(props.title, this.props.lang, this.props.translatedData)}</h4>
            <Table
              className="service-history-table"
              data={this.props.serviceHistory || []}
              useObjectKeys={false}
              tableMeta={meta}
            />
          </div> : ''
      )
    }
  }
  getDropDownOps = (ddname, apiUrl, dropdownType, options, mandatory, mandatoryMessage, helpText, isVisible, isDisabled, tooltipText, _value) => {
    let _valueForEditMode = "";
    let _selectedOptionText = "";
    let showPleaseSelect = false;

    if (this.props.properties.formData[ddname]) {
      _valueForEditMode = this.props.properties.formData[ddname].id || this.props.properties.formData[ddname].value;
      if (ddname === 'productType' || ddname === 'GdocsTerms') {
        _valueForEditMode = _valueForEditMode === undefined ? this.props.properties.formData[ddname] : _valueForEditMode;
      }
      _selectedOptionText = this.props.properties.formData[ddname].name;
    } else if (this.props.properties[ddname]) {
      _valueForEditMode = this.props.properties[ddname];
      _selectedOptionText = this.props.properties[ddname].name;
    }

    let disabled = isDisabled;

    if (this.props.customer !== undefined) {
      if (ddname === 'country' && this.props.customer.roleDetails.customer) {
        apiUrl = apiUrl + '?service=account&caseId=' + this.props.owningCase.caseId
      }
    }
    if (this.props.productType === "manual-case-add-product" && ddname === "country" && !this.props.msaCases) {
      apiUrl = apiUrl + "?caseType=manual-case"
    }
    if (ddname === 'countryOfRegistration') {
      showPleaseSelect = true
      disabled = false;
    }

    if (this.props.mode === "edit") {
      // if(typeof this.props.newEntities !== 'undefined'  && this.props.newEntities.length > 0 && typeof this.props.currentCustomerDetailsEntityId !== 'undefined'){
      //   if((this.props.newEntities.indexOf(this.props.currentCustomerDetailsEntityId) === -1) && ddname === 'businessSegment'){
      //     this.state.formData[ddname].value = '';
      //   }
      // }
      // In businessSegment HO(Admin, CI user) can edit only
      if (ddname === 'businessSegment' && this.props.customer !== undefined && !this.props.customer.roleDetails.customer) {
        disabled = false;
        showPleaseSelect = true;
      }
      if ((ddname === 'businessSegment' && this.props.customer !== undefined && this.props.customer.roleDetails.customer && document.getElementById('businessSegmentField') !== null)) {
        document.getElementById(this.getFieldId('businessSegment')).classList.add('noDisplay');
      }

      if (this.props.customer !== undefined) {
        if (this.props.customerEchannel === "true") {
          if ((ddname === 'profileOwner' || ddname === 'country' || ddname === 'eChannelType') && this.props.currentProductEchannel.data.newEchannel && this.props.customer.roleDetails.customer) {
            disabled = true;
          }
          if ((ddname === 'eChannelType') && !this.props.currentProductEchannel.data.newEchannel && this.props.customer.roleDetails.customer) {
            disabled = false;
          }
        }
      }

      //Gls restrictions

      else if (ddname === 'frequencyType' && this.props.customer !== undefined && this.props.customer.roleDetails.customer) {
        disabled = true;
      }
      if (ddname === 'frequencyDetails' && this.props.customer !== undefined && this.props.customer.roleDetails.customer) {
        disabled = true;
      }

      else if (ddname === 'forcePartialReject' && this.props.customer !== undefined && this.props.customer.roleDetails.customer) {
        disabled = true;
      }
      else if (ddname === 'balanceType' && this.props.customer !== undefined && this.props.customer.roleDetails.customer) {
        disabled = true;
      }
      else if (ddname === 'backValuedSweepOption' && this.props.customer !== undefined && this.props.customer.roleDetails.customer) {
        disabled = true;
      }
      else if (ddname === 'reverseSweepOption' && this.props.customer !== undefined && this.props.customer.roleDetails.customer) {
        disabled = true;
      }
      else if (ddname === 'masterHolidaySweepOption' && this.props.customer !== undefined && this.props.customer.roleDetails.customer) {
        disabled = true;
      }
      else if (ddname === 'sweepTimeZone' && this.props.customer !== undefined && this.props.customer.roleDetails.customer) {
        disabled = true;
      }
      //other Sweep options
      else if (ddname === 'creditFirstGroupSweepRule' && this.props.customer !== undefined && this.props.customer.roleDetails.customer) {
        disabled = true;
      }
      else if (ddname === 'weightedAverageGroupSweepRule' && this.props.customer !== undefined && this.isReadOnly()) {
        disabled = true;
      }
      //CCR Interest
      else if (ddname === 'settlementType' && this.props.customer !== undefined && this.props.customer.roleDetails.customer) {
        disabled = true;
      }
      if (ddname === 'settlementType' && this.state.formData['interestPeriod'] && this.state.formData['interestPeriod'].isNAChecked !== undefined) {
        if (this.props.customer !== undefined && this.props.customer.roleDetails.customer) {
          disabled = true;
        }
        else if (this.state.formData['interestPeriod'].isNAChecked === true) {
          disabled = true;
        } else if (this.state.formData['interestPeriod'].isNAChecked === false) {
          disabled = false;
        }
      }
      else if (ddname === 'resetFrequency' && this.props.customer !== undefined && this.props.customer.roleDetails.customer) {
        disabled = true;
      }
      //CCR Bilateral Limits
      else if (ddname === 'limitType' && this.props.customer !== undefined && this.props.customer.roleDetails.customer) {
        disabled = true;
      }
      else if (ddname === 'lendingLimitBreachAction' && this.props.customer !== undefined && this.props.customer.roleDetails.customer) {
        disabled = true;
      }
      else if (ddname === 'borrowingLimitBreachAction' && this.props.customer !== undefined && this.props.customer.roleDetails.customer) {
        disabled = true;
      }
      else if (ddname === 'relationshipBank' && this.props.customer !== undefined && this.props.customer.roleDetails.customer) {
        disabled = true;
      }
      //Ach Other Account And country disabled
      else if ((ddname === 'accountHolder' || ddname === 'country' || ddname === 'currency') && this.props.properties.editType === 'create-ach-other-account') {
        disabled = true;
      }

      if (ddname === 'chequeBookTypes') {
        if (this.state.formData[ddname] === undefined) {
          var currentWord = Translations(options, this.props.lang, this.props.translatedData)
          var options = convertStringToArrayForOption(currentWord);
          var splitOption = options[2].split('=');
          let setDefaultValue = {};
          let chequeBookTypes = {
            name: splitOption[0],
            value: splitOption[1]
          }
          setDefaultValue = { ...this.state.formData, chequeBookTypes: chequeBookTypes }
          this.setState({
            formData: setDefaultValue
          })
        }
      }
      if (ddname === 'resetFrequency') {
        var _currentWord = Translations(options, this.props.lang, this.props.translatedData)
        var _options = convertStringToArrayForOption(_currentWord);
        var _splitOption = _options[1].split('=');
        let setDefaultValue = {};
        if (this.state.formData[ddname] === undefined) {
          let resetFrequency = {
            name: _splitOption[1],
            value: _splitOption[0]
          }
          setDefaultValue = { ...this.state.formData, resetFrequency: resetFrequency }
          this.setState({
            formData: setDefaultValue
          })
        }
      }
      if (ddname === 'settlementType' && this.state.formData['settlementType'] === undefined) {
        let setDefaultValue = {};
        let settlementType = {
          name: "Gross",
          value: "gross"
        }
        setDefaultValue = { ...this.state.formData, settlementType: settlementType }
        this.setState({
          formData: setDefaultValue
        })

      }
      if (ddname === 'settlementType' && this.state.formData['interestPeriod'] && this.state.formData['interestPeriod'].isNAChecked !== undefined) {
        if (this.state.formData['interestPeriod'].isNAChecked === true) {
          disabled = true;
        } else if (this.state.formData['interestPeriod'].isNAChecked === false) {
          disabled = false;
        }
      }
      if (ddname === 'reverseSweepOption' && this.state.formData['reverseSweepOption'] !== undefined && document.getElementsByName('reverseSweepOption') !== undefined && document.getElementById('reverseSweepHolidaySkipField') !== null) {
        if (this.state.formData['reverseSweepOption'].value === 'yes') {
          document.getElementById('reverseSweepHolidaySkipField').classList.remove('noDisplay');
        } else {
          document.getElementById('reverseSweepHolidaySkipField').classList.add('noDisplay');
        }
      }
    }

    if (ddname === "glsProductType" && this.state.formData['glsProductType'] !== undefined) {
      if (this.state.formData['glsProductType'].value === "notionalPool") {
        if (this.state.formData['location'] === undefined) {
          if (this.inValidFields.indexOf('location') === -1) {
            this.inValidFields.push("location");
          }
        } else if (this.props.mode === "edit" && this.props.resetDisable) {
          disabled = true;
        } else {
          this.inValidFields.remove("location");
        }
      }
      if (this.state.formData['glsProductType'].value === "cashcon" || this.state.formData['glsProductType'].value === "interest") {
        if (this.state.formData['relationshipBank'] === undefined) {
          if (this.inValidFields.indexOf('relationshipBank') === -1) {
            this.inValidFields.push("relationshipBank");
          }
        } else if (this.props.mode === "edit" && this.props.resetDisable) {
          disabled = true;
        } else {
          this.inValidFields.remove("relationshipBank");
        }
      }
      else if (this.state.formData['glsProductType'].value === "cashcon" && this.props.mode === "edit" && this.props.resetDisable) {
        disabled = true;
      }
      else if (this.state.formData['glsProductType'].value === "interest" && this.props.mode === "edit" && this.props.resetDisable) {
        disabled = true;
      }
    }
    if (ddname === "location" && this.props.resetDisable && this.state.formData['glsProductType'] !== undefined && this.state.formData['glsProductType'].value === "notionalPool" && this.props.mode === "edit") {
      disabled = true;
    }
    if (ddname === "glsProductType" && this.state.formData['glsProductType'] !== undefined && (this.state.formData['glsProductType'].value === "cashcon" || this.state.formData['glsProductType'].value === "interest")) {
      this.inValidFields.remove("location");
    }

    if (ddname === "productType" && this.state.formData['productType'] !== undefined && this.state.formData['productType'].name !== 'Other') {
      this.inValidFields.remove("otherProductValue");
    }
    if (ddname === "productType" && this.state.formData['productType'] !== undefined && this.state.formData['productType'].name === 'Other' && this.state.formData['otherProductValue'] === undefined) {
      this.addInvalidField("otherProductValue");
    }
    if (ddname === "country" && this.state.formData['country'] !== undefined && this.state.formData['country'].name !== 'Other') {
      this.inValidFields.remove("otherCountryValue");
    }
    if (ddname === "country" && this.state.formData['country'] !== undefined && this.state.formData['country'].name === 'Other' && this.state.formData['otherCountryValue'] === undefined) {
      this.addInvalidField("otherCountryValue");
    }
    if (this.props.properties.editType === "add-manual-case-basic-details") {
      if (ddname === "countryOfRegistration" || ddname === "businessSegment") {
        disabled = this.props.formDisabled;
        if (this.props.msaCases) {
          if (document.getElementById('countryOfRegistrationField')) document.getElementById('countryOfRegistrationField').classList.add('noDisplay');
          if (document.getElementById('businessSegmentField')) document.getElementById('businessSegmentField').classList.add('noDisplay');
          if (document.getElementById('GdocsTermsField')) document.getElementById('GdocsTermsField').classList.add('noDisplay');
        }
        else {
          if (document.getElementById('businessSegmentField') !== null && document.getElementById('countryOfRegistrationField') !== null && document.getElementById('GdocsTermsField') !== null) {
            document.getElementById('countryOfRegistrationField').classList.remove('noDisplay');
            document.getElementById('businessSegmentField').classList.remove('noDisplay');
            document.getElementById('GdocsTermsField').classList.remove('noDisplay');
          }
        }

      }
      if (ddname === "GdocsTerms") {
        disabled = true;
      }
      if (ddname === "countryOfIncorporation") {
        disabled = this.props.formDisabled;
      }
    }

    if (this.props.properties.editType === "product-requests-form") {
      if (ddname === "productType" && this.props.mode === 'edit') {
        disabled = true;
      }
    }

    if (ddname === "status") {
      disabled = this.props.formDisabled;
      showPleaseSelect = true;
    }

    if (ddname === 'countryOfCaseOwner') {
      disabled = this.props.formDisabled;
    }

    var currentWord = Translations(options, this.props.lang, this.props.translatedData)

    var options = convertStringToArrayForOption(currentWord);

    if (ddname === "cancelationReason") {
      var currentWord = Translations(_value, this.props.lang, this.props.translatedData)
      var value = convertStringToArray(currentWord);
      var options = [];
      value.map((option, index) => {
        options[index] =
        {
          id: option,
          name: option
        }
      })
      _value = "Please Select"
      if (this.state.formData['cancelledDate'] === undefined) {
        disabled = true;
      } else {
        disabled = false;
      }
    }

    if (this.props.navigatedFrom === 'gls-np-interest-optimization' || this.props.navigatedFrom === 'gls-ie-detailed-settings') {
      disabled = this.isReadOnly()
    }

    if (this.props.formDisabled && ddname === 'businessSegment') {
      disabled = false
      this.removeInvalidField(ddname)
    }
    // if(this.props.lang !== undefined){
    //   if(this.props.lang === "Spanish" && this.state.formData[ddname] !== '' && this.state.formData[ddname] !== undefined){
    //     this.state.formData[ddname].value = this.setLangChangeDropDown("EN","BA", this.state.formData[ddname].value, "ES", dropdownType);
    //   }
    //   else if(this.props.lang === "English" && this.state.formData[ddname] !== '' && this.state.formData[ddname] !== undefined){
    //     this.state.formData[ddname].value = this.setLangChangeDropDown("ES","BA", this.state.formData[ddname].value, "EN", dropdownType);
    //   }
    //   else if(this.props.lang === "Bahasa" && this.state.formData[ddname] !== '' && this.state.formData[ddname] !== undefined){
    //     this.state.formData[ddname].value = this.setLangChangeDropDown("ES","EN", this.state.formData[ddname].value, "BA", dropdownType);
    //   }
    // }

    const { pathname, country, accountType, currency, editType, setCountry, setCurrency, currentCaseId, tempRefCaseId } = this.props.properties;

    return (
      <Dropdown properties={{ setTempRefForAccount: this.getTempRefForAccount, pathname, country, accountType, currency, editType, setCountry, setCurrency, currentCaseId, tempRefCaseId }}
        ddname={ddname}
        id={ddname}
        resourcesUrl={apiUrl}
        type={dropdownType}
        options={options}
        mandatory={mandatory}
        mandatoryMessage={Translations(mandatoryMessage, this.props.lang, this.props.translatedData)}
        helpText={helpText}
        disabled={disabled}
        CaseRecordToggle={this.props.CaseRecordToggle}
        CreateNewToggle={this.props.CreateNewToggle}
        resetData={this.props.resetData}
        ResetForm={this.props.ResetForm}
        tooltipText={tooltipText}
        renderNewAccountField={this.setNewAccountField}
        value={this.state.formData[ddname] && this.state.formData[ddname].value ? this.state.formData[ddname].value : _valueForEditMode}
        _value={_valueForEditMode}
        _selectedOptionText={_selectedOptionText}
        setFieldValidtionState={this.setFieldValidtionState}
        setDropdownvalue={this.setFormElementData}
        fieldPrefix={this.props.fieldPrefix}
        validData={this.validData}
        showPleaseSelect={showPleaseSelect}
        lang={this.props.lang}
        flag={this.props.flag}
        pleaseSelectcValue={_value}
        translatedData={this.props.translatedData}
        formData={this.state.formData}
        existingEntityData={this.props.properties.existingEntityData}
        bankData={this.props.bankData}
        mode={this.props.mode}
        modalText={this.props.modalText ? this.props.modalText : ''}
        productList={this.props.productList}
        productType={this.props.productType}
        showLoaderOnFetchApiResource={this.props.showLoaderOnFetchApiResource}
        isRepeatingComponentWithSameResourceUrl={this.props.isRepeatingComponentWithSameResourceUrl}
        cachedResourceData={this.props.cachedResourceData && this.props.cachedResourceData["dropdown_" + ddname]}
      />
    );
  }

  generateComboBoxJsx = ({ title, name, comboDropdownName, comboInputName, resourcesUrl, minChars, maxChars, mandatory, mandatoryMessage, isDisabled, isVisible, _value }, elementKey) => {
    const visibilityCss = classnames("form-group row", {
      noDisplay: isVisible === 'false'
    });
    let disabled = false;
    if (this.props.mode === "edit") {
      disabled = isDisabled;
    }
    const _jsx = (
      <div key={elementKey} className={visibilityCss} id={`${this.props.fieldPrefix || ""}${name}Field`}>
        <label className="col-lg-4" for={name}>{Translations(title, this.props.lang, this.props.translatedData)}</label>
        <div className="col-lg-8 col-sm-12">
          <ComboBox name={name}
            defaultValue={Translations(_value, this.props.lang, this.props.translatedData)}
            comboDropdownName={comboDropdownName}
            comboInputName={comboInputName}
            resourcesUrl={resourcesUrl}
            min={minChars}
            max={maxChars}
            mandatory={mandatory}
            mandatoryMessage={Translations(mandatoryMessage, this.props.lang, this.props.translatedData)}
            disabled={disabled}
            _value={this.props.properties.formData[comboInputName] || this.props.properties[comboInputName]}
            _dropdownValue={this.props.properties.formData[comboDropdownName] || this.props.properties[comboDropdownName]}
            setComboBoxvalue={this.setFormElementData}
            setFieldValidtionState={this.setFieldValidtionState}
            fieldPrefix={this.props.fieldPrefix} />
        </div>
      </div>
    );

    return _jsx;
  }

  generateFormHeaderJsx = ({ name, subNames, cssClass, isVisible }, elementKey) => {
    const visibilityCss = classnames("form-group row", {
      noDisplay: isVisible === 'false'
    });
    const textCss = classnames("col-lg-12", cssClass);
    const _jsx = (
      <div key={elementKey} className={visibilityCss} id={`${this.props.fieldPrefix || ""}${name}Field`}>
        {this.props.formHeader || "Form header"}
      </div>
    );

    return _jsx;
  }

  generateReadonlytextJsx = ({ name, value, title }, elementKey) => {
    const _jsx = (
      <div className="form-group row" id={`${this.props.fieldPrefix || ""}${name}Field`}>
        <label className="col-lg-4 form-column__label">{Translations(title, this.props.lang, this.props.translatedData)}</label>
        <div className="col-lg-8 col-lg-12">
          <label>{this.state.formData.ccrRefId !== undefined && name === 'ccrRef' ? this.state.formData['ccrRefId'] : Translations(value, this.props.lang, this.props.translatedData)}</label>
        </div>
      </div>
    );
    return _jsx;
  }


  generateTextJsx = ({ name, text, cssClass, isVisible }, elementKey) => {
    const visibilityCss = classnames("form-group row", {
      noDisplay: isVisible === 'false'
    });
    const textCss = classnames("col-lg-12", {
      'gdocs-input-error': this.inValidFields.includes("csProjectNumber") ? true : false,
      [cssClass]: cssClass
    });
    const _jsx = (
      <div key={elementKey} className={visibilityCss} id={`${this.props.fieldPrefix || ""}${name}Field`}>
        <label className={textCss} name={name} id={name}>
          {Translations(text, this.props.lang, this.props.translatedData)}
        </label>
      </div>
    );

    return _jsx;
  }

  generateAutoCompleteTextBoxJsx = ({ title, cssClass, isVisible, mandatoryMessage, mandatory }, elementKey) => {
    let value;
    const visibilityCss = classnames("form-group row", {
      noDisplay: isVisible === 'false'
    });
    let name = elementKey.split("_")[1]
    if (this.props.properties.formData[name]) {
      value = this.props.properties.formData[name].name
    }

    const _jsx = (
      <div key={elementKey} className={visibilityCss} id={`${this.props.fieldPrefix || ""}${name}Field${this.props.italyIndex !== undefined ? this.props.italyIndex : ''}`}>
        <label className="col-lg-4" id={name}>{Translations(title, this.props.lang, this.props.translatedData)}</label>
        <div className="col-lg-8 col-sm-12">
          <AutoCompleteTextBox
            name={name}
            _value={value}
            filterList={this.props.filterList}
            options={this.props.options}
            setSelectedOptions={this.props.setSelectedOptions}
            setInputvalue={this.setFormElementData}
            mandatoryMessage={Translations(mandatoryMessage, this.props.lang, this.props.translatedData)}
            mandatory={mandatory}
            displayOptions={this.props.displayOptions}
            setFieldValidtionState={this.setFieldValidtionState}
            showOptions={this.props.showOptions !== undefined ? this.props.showOptions[name] : false}
          />
        </div></div>
    );

    return _jsx;
  }
  generateSubmitButtonJsx = (props, elementKey) => {
    let disableOnclick = ((this.props.disableSubmitOnClick === undefined || this.props.disableSubmitOnClick === true) && (this.props.btnDisabled !== false && this.props.btnDisabled !== undefined)) ? true : false;
    props.disabled = !this.state.formTouched || this.state.formInvalid || this.inValidFields.length > 0;
    props.translatedText = Translations(props.text, this.props.lang, this.props.translatedData);

    if (((typeof props.disabled === "string" && props.disabled.toLocaleLowerCase() === "true") || (typeof props.disabled === "boolean" && props.disabled)) && this.props.productType === "capture-cash-flow-forecasting-basic-details") {
      props.disabled = true
    }
    else if (elementKey === 'guidebutton_save') {
      props.disabled = false
      disableOnclick = false
    }
    if (this.props.mode === 'edit' && this.props.setEchanelBtn === true) {
      props.disabled = false;
    }
    if (this.props.mode === 'edit' && (this.props.setAccountBtnOnCancel === true && this.inValidFields.length === 0)) {
      props.disabled = false;
    }
    if (this.props.properties.editType === "add-ach-to-case") {
      const { achCredit, cin, entity } = this.state.formData;
      if (!isEmpty(entity)) {
        if (!isEmpty(achCredit)) {
          let isUKCheck = this.validateField(achCredit)
          if (!isEmpty(isUKCheck)) {
            if (isEmpty(cin)) {
              props.disabled = true;
            } else {
              props.disabled = (cin.length == 10) ? false : true
            }
          } else {
            /*achCredit.map(v => {
              if (v.name.indexOf(ACH_UK) == -1) {
                props.disabled = false;
              } else {
                props.disabled = true;
              }
            })*/
            props.disabled = false;
          }
        } else {
          props.disabled = true;
        }
      } else {
        props.disabled = true;
      }
    }

    if (this.props.productType === "gls-sow-create-entity") {
      props.disabled = !Boolean(this.props.entityList && this.props.entityList.length)
    }

    if (this.props.productType === "gls-sow-edit-entity") {
      props.disabled = Boolean(this.state.formData && this.state.formData.registeredName === "")
    }

    if (this.props.productType === "gls-echannel-create-other-account") {
      props.disabled = !Boolean(this.state.formData && this.state.formData.accountId &&
        ((this.state.formData.accountHolder && this.state.formData.accountHolder.value) ||
          (this.state.formData.otherEntityAccountHolder && this.state.formData.otherEntityAccountHolder.value)))
    }
    if (this.props.sow && this.isReadOnly()) {
      props.disabled = true
    }

    if (this.props.productType === "activate-cashFlowForecasting" && this.props.isCMP) {
      props.disabled = false
    }

    if (this.props.isTnC) {
      props.disabled = false
    }
    if (this.props.properties.editType === "convert-echannel" && this.props.properties.formData.newEchannel === true) {
      props.disabled = false
    }

    const _jsx = (
      <FormButton {...props} key={elementKey} _onClick={this.props.onFormSubmit} disableOnclick={disableOnclick} />
    );

    return _jsx;
  }

  saveStateToSessionOnEdit = () => {
    if (this.props.previousPageLevel2) {
      savePageStateInSessionStorageLevel2(this.props.pageState, this.props.history.location.pathname);
    } else {
      savePageStateInSessionStorage(this.props.pageState, this.props.history.location.pathname);
    }
  }

  generateCanelButtonJsx = (props, elementKey) => {
    props.translatedText = Translations(props.text, this.props.lang, this.props.translatedData);

    const _jsx = (
      <FormButton {...props} key={elementKey} _onClick={this.props.onFormCancel} />
    );

    return _jsx;
  }

  onSingleLineSelectOptionsDataExists = (doesExists, singleSelectType) => {
    if (doesExists === true) {
      this.setState({ [singleSelectType]: true });
    }
  }
  handleSingleSelectEditClick = (selectedItem, editFormLink) => {
    if (selectedItem && selectedItem.id) {
      this.saveStateToSessionOnEdit();
      this.props.history.push(editFormLink + "/" + selectedItem.id);
    }
  }

  handleMultiSelectEditClick = (accountSignatory, editFormLink) => {
    if (accountSignatory && accountSignatory.id) {
      this.saveStateToSessionOnEdit();
      this.props.history.push(editFormLink + "/" + accountSignatory.id);
    }
  }

  getSelectedValue = (data) => {
    if (this.props.isAssociation === false) {
      this.setFormElementData(data, 'productDetails')
    }
    else {
      this.setFormElementData(data, 'achCredit')
    }
  };

  handleSingleSelectChange = (selectedItem, singleSelectType) => {
    //this.saveStateToSessionOnEdit();
    this.setFormElementData(selectedItem.id, singleSelectType);
  }
  handleMultiSelectChange = (selectedItem, multiSelectType) => {
    this.setFormElementData(selectedItem.id, multiSelectType);

    // var _accountSignatories = [...this.state.currentAccount.accountSignatories];
    // _accountSignatories[index] = {id: accountSignatory.id};
    //
    // this.disableList.indexOf(accountSignatory.id) === -1 && this.disableList.includes(accountSignatory.id)
    // ? this.disableList.push(accountSignatory.id)
    // : this.disableList
    //
    // this.disableList[index] = accountSignatory.id
    //
    // this.setState(prevState =>({
    //   disabledAccountSignatory: this.disableList,
    //   currentAccount: {...this.state.currentAccount, accountSignatories: _accountSignatories},
    //   showAddAccountSignatoryBtn: true,
    // }));

  }
  generateSingleSelectJsx = ({ defaultValue, requiredFields, resourceURL, createLink, createLinkText, editFormLink, singleSelectType, name, title, isVisible, _value, countryTaxonomyUrl }, elementKey) => {
    const visibilityCss = classnames("form-group row", {
      noDisplay: isVisible === 'false'
    });
    const _defaultValue = Translations(_value, this.props.lang, this.props.translatedData);
    const _jsx = (
      <div key={elementKey} className={visibilityCss} id={`${this.props.fieldPrefix || ""}${name}Field${this.props.italyIndex !== undefined ? this.props.italyIndex : ''}`}>
        <label className="col-lg-4" for={name}>{Translations(title, this.props.lang, this.props.translatedData)}</label>
        <div className="col-lg-8 col-sm-12 single-select-box-wrapper">
          <SingleLineSelect defaultValue={_defaultValue || "Please Select"}
            requiredFields={requiredFields || []}
            id={name}
            resourceURL={resourceURL + "/" + this.props.owningCase.caseId}
            selectType={singleSelectType}
            countryTaxonomyUrl={Translations(countryTaxonomyUrl, this.props.lang, this.props.translatedData)}
            _value={this.props.properties.formData[name]}
            optionsData={this.props.optionsData || []}
            _onChange={this.handleSingleSelectChange}
            _onOptionsDataExists={this.onSingleLineSelectOptionsDataExists}
            editFormLink={editFormLink}
            onEdit={this.handleSingleSelectEditClick}
            fieldPrefix={this.props.fieldPrefix}
            taxanomyURL={this.props.taxanomyURL}
            countrytaxanomyList={this.props.countrytaxanomyList || []} />
          <PersistLink className="create-link"
            to={createLink}
            history={this.props.history}
            state={this.props.pageState}
            data={`${name}${this.props.pageState.countryItalyForm !== undefined ? this.props.pageState.countryItalyForm.signatoryDeclaration[this.props.italyIndex] !== undefined ? this.props.pageState.countryItalyForm.signatoryDeclaration[this.props.italyIndex].accountSignatoryId : '' : ''}`}>
            {Translations(createLinkText, this.props.lang, this.props.translatedData)}
          </PersistLink>
        </div>
      </div>
    );

    return _jsx;
  }

  onEchannelReportingAddition = (e, name) => {
    e.preventDefault()
    if (this.state.formData && this.state.formData[name]) {
      const newFormData = { ...this.state.formData }
      newFormData[name].push("")
      this.props.properties.formData[name] = ''
      this.setState({ formData: newFormData })
    }
  }

  getGlsReports = (name) => {
    if (this.props.properties && this.props.properties.formData && this.props.properties.formData[name]) {
      return this.props.properties.formData[name]
    }
    return this.state.formData.glsReports && this.state.formData.glsReports.length ? this.state.formData.glsReports : ['']
  }

  generateMultiSelectJsx = ({ defaultValue, requiredFields, resourceURL, createLink, createLinkText, editFormLink, multiSelectType, name, title, isVisible, _value, repeatCount = 1, applyToAll = '' }, elementKey) => {
    const visibilityCss = classnames("form-group row", {
      noDisplay: isVisible === 'false'
    });
    const _defaultValue = Translations(_value, this.props.lang, this.props.translatedData);

    let glsReportingJsx = []
    let customLink = createLink;
    customLink = this.props.isEchannelRestricted ? createLink + '/isEchannelRestricted' : createLink;

    if (name === "glsReports") {
      for (let reportIndex = 0; reportIndex < ((this.state.formData[name] && this.state.formData[name].length) || repeatCount); reportIndex++) {
        glsReportingJsx.push(
          <div key={`${elementKey}_${reportIndex}`} className={visibilityCss} id={`${this.props.fieldPrefix || ""}${name}Field${this.props.italyIndex !== undefined ? this.props.italyIndex : ''}`}>
            <label className="col-lg-4" for={name}>{this.getTranslation(title) + " " + (reportIndex + 1)}</label>
            <div className={classnames("col-lg-8 col-sm-12 single-select-box-wrapper gls-reporting-multidropdown", { "disabled": this.isReadOnly() })} style={{
              position: "relative"
            }}>
              {reportIndex > 0 ?
                < section className='gls-reporting-delete-icon' onClick={(e) => {
                  e.preventDefault()
                  if (this.state.formData && this.state.formData[name]) {
                    this.updateFormState({ [name]: this.state.formData[name].filter((el, elIndex) => elIndex !== reportIndex) })
                  }
                }}>
                  <span class="delete-btn" role="button"><i class="icon icon-bin"></i></span>
                </section> :
                null
              }
              <div className='gdocs-display-flex gdocs-align-item-center'>
                <MultiLineSelect defaultValue={_defaultValue || 'Please select'}
                  requiredFields={this.props.requiredFields || requiredFields}
                  disabledOptions={this.props.disabledList || []}
                  data={this.props.reportingEchannels || []}
                  value={this.props.properties.formData[name] ? this.props.properties.formData[name][reportIndex] : this.state.formData[name] ? this.state.formData[name][reportIndex] : ''}
                  selectType={multiSelectType}
                  showEdit={false}
                  _onChange={(dataObj, multiType) => {
                    const newFormData = { ...this.state.formData }
                    if (newFormData[name]) {
                      newFormData[name][reportIndex] = dataObj.id
                    }
                    this.setState({
                      formData: { ...newFormData }
                    })
                  }}
                  multiAccount={true}
                  formatters={this.props.formatters}
                />
                {
                  reportIndex < 1 ?
                    <button class={classnames("gdocs-btn-default gdocs-ml-1rem", { "disabled": !this.state.formData[name][reportIndex] })}
                      onClick={(e) => {
                        e.preventDefault();
                        this.props.handleGlsReportingApplyToAll && this.props.handleGlsReportingApplyToAll(reportIndex, this.state.formData[name][reportIndex])
                      }}
                    >
                      {this.getTranslation(applyToAll || "Apply to all")}
                    </button>
                    : null
                }
              </div>
              <span class="icon icon-add addicon"></span>
              <PersistLink className="create-link"
                to={customLink}
                history={this.props.history}
                state={this.props.pageState}
                previousPageLevel2={this.props.previousPageLevel2}
                data={`${name}-${"accountInterestLimitIndex" in this.props.properties && this.props.properties.accountInterestLimitIndex}-${reportIndex}`}
              >
                {Translations(createLinkText, this.props.lang, this.props.translatedData)}
              </PersistLink>
            </div>
          </div >
        )
      }

      if (this.state.formData[name] && this.state.formData[name].length && this.state.formData[name].length < 2) {
        glsReportingJsx.push(
          <section style={{ marginBottom: 15 }}>
            <section className='col-lg-4'>
            </section>
            <button className={classnames("gdocs-btn-default", { "disabled": this.isReadOnly() })} onClick={(e) => this.onEchannelReportingAddition(e, name)}>
              <i className="icon icon-add"></i>{`${this.getTranslation(title || "Add GLS Reporting")} ${((this.state.formData && this.state.formData.glsReports &&
                this.state.formData.glsReports.length) || repeatCount) + 1}`}
            </button>
          </section>

        )
      }
    }


    const _jsx = name === "glsReports" ?
      <React.Fragment>
        {glsReportingJsx}
      </React.Fragment>
      : (
        <div key={elementKey} className={visibilityCss} id={`${this.props.fieldPrefix || ""}${name}Field${this.props.italyIndex !== undefined ? this.props.italyIndex : ''}`}>
          <label className="col-lg-4" for={name}>{Translations(title, this.props.lang, this.props.translatedData)}</label>
          <div className="col-lg-8 col-sm-12 single-select-box-wrapper">
            <MultiLineSelect defaultValue={_defaultValue || 'Please select'}
              requiredFields={this.props.requiredFields || requiredFields}
              flag={true}
              disabledOptions={this.props.disabledList !== undefined ? this.props.disabledList : ''}
              data={this.props.accountsData !== undefined ? this.props.accountsData : []}
              value={this.props.properties.formData[name] !== undefined ? this.props.properties.formData[name] : ''}
              selectType={multiSelectType}
              onEdit={this.handleMultiSelectEditClick}
              _onChange={this.handleMultiSelectChange}
              editFormLink={editFormLink} />
            <PersistLink className="create-link"
              to={customLink}
              history={this.props.history}
              state={this.props.pageState}
              previousPageLevel2={this.props.previousPageLevel2}
              data={`${name}${this.props.pageState.countryItalyForm && this.props.pageState.countryItalyForm.signatoryDeclaration[this.props.italyIndex] ?
                this.props.pageState.countryItalyForm.signatoryDeclaration[this.props.italyIndex].accountSignatoryId : ''}`}
            >
              {Translations(createLinkText, this.props.lang, this.props.translatedData)}
            </PersistLink>
          </div>
        </div>
      );

    return _jsx;
  }

  generateMultiSelectJsx1 = ({ defaultValue, requiredFields, resourceURL, createLink, createLinkText, editFormLink, multiSelectType, name, title, isVisible, _value }, elementKey) => {

    const visibilityCss = classnames("form-group row", {
      noDisplay: this.props.isvisible
    });
    var disabled
    if (this.isReadOnly()) {
      disabled = true
    }
    const _defaultValue = Translations(_value, this.props.lang, this.props.translatedData);

    const _jsx = this.props.isvisible ? '' : (
      <div key={elementKey} className={visibilityCss} id={`${this.props.fieldPrefix || ""}${name}Field${this.props.italyIndex !== undefined ? this.props.italyIndex : ''}`}>
        <label className="col-lg-4" for={name}>{Translations(title, this.props.lang, this.props.translatedData)}</label>
        <div className="col-lg-8 col-sm-12 single-select-box-wrapper">
          {
            (this.props.addressData !== undefined && this.props.addressData.length > 0) ?
              (
                <SingleLineSelect defaultValue={_defaultValue || "Please Select"}
                  id={name}
                  requiredFields={["addressLine1", "addressLine2", "addressLine3", "city", "state", "country"]}
                  selectType={multiSelectType || name}
                  _value={this.props.properties.formData[name] !== undefined ? this.props.properties.formData[name] : ''}
                  optionsData={this.props.addressData || []}
                  _onChange={this.handleSingleSelectChange}
                  _onOptionsDataExists={this.onSingleLineSelectOptionsDataExists}
                  editFormLink={editFormLink}
                  onEdit={this.handleSingleSelectEditClick}
                  isreadonly={disabled}
                />
              ) : ''}
          <PersistLink className="create-link"
            to={createLink}
            history={this.props.history}
            state={this.props.pageState}
            previousPageLevel2={this.props.previousPageLevel2}
            data={name}
            disabled={disabled}
            isDisable={disabled}>
            {Translations(createLinkText, this.props.lang, this.props.translatedData)}

          </PersistLink>
        </div>
      </div>
    );

    return _jsx;
  }

  updateFormState = (obj = {}) => {
    if (!isEmptyObject(obj)) {
      this.setState({
        formData: {
          ...this.state.formData, ...obj
        }
      })
    }
  }

  generateOptionalTextBox = ({ title, name, minChars, maxChars, isVisible, naValue }, elementKey) => {
    const visibilityCss = classnames("form-group row", {
      noDisplay: isVisible === 'false'
    });
    let disabled = false
    if (this.isReadOnly()) {
      disabled = true
    }

    if (name === "odLimit") {
      if (this.state.formData[name] && this.state.formData[name].toLowerCase() === "n/a") {
        if (this.state.formData.odLimitTierStatus !== undefined) {
          this.updateFormState({ odLimitTierStatus: undefined })
        }
      } else {
        if (this.state.formData.odLimitTierStatus === undefined) {
          this.updateFormState({ odLimitTierStatus: "notiering" })
        }
      }
    }

    const _jsx = (
      <div key={elementKey} className={visibilityCss} id={`${this.props.fieldPrefix || ""}${name}Field${this.props.italyIndex !== undefined ? this.props.italyIndex : ''}`}>
        <label className="col-lg-4" id={name + this.state.randomIdx}>{Translations(title, this.props.lang, this.props.translatedData)}</label>
        <div className="col-lg-8 col-sm-12">
          <OptionalTextBox name={name}
            _value={this.props.properties.formData[name] || this.props.properties[name]}
            min={minChars}
            max={maxChars}
            disabled={disabled}
            setInputvalue={this.setFormElementData}
            fieldPrefix={this.props.fieldPrefix} />
        </div>
      </div>
    );
    return _jsx;
  }

  generateInterestComboBox = ({ name, boxLabel, subLabels, subNames, isVisible, maxChars, radioValues, defaultValue }, elementKey) => {
    const visibilityCss = classnames("form-group row", {
      noDisplay: isVisible === 'false'
    });
    var disabled = false
    if (this.isReadOnly()) {
      disabled = true
    }

    var boxLabelTranslated = Translations(boxLabel, this.props.lang, this.props.translatedData);
    var currentWord = Translations(subLabels, this.props.lang, this.props.translatedData)
    var convertedArray = convertStringToArrayForOption(currentWord);
    const _jsx = (
      <div key={elementKey} className={visibilityCss} id={`${this.props.fieldPrefix || ""}${name}Field${this.props.italyIndex !== undefined ? this.props.italyIndex : ''}`}>
        <div className="col-lg-12 col-sm-12">
          <InterestComboBox name={name}
            boxLabel={boxLabelTranslated}
            subLabels={convertedArray}
            subNames={subNames}
            maxChars={maxChars}
            disabled={disabled}
            defaultValue={defaultValue}
            _value={this.props.properties.formData[name] || this.props.properties[name]}
            setInputvalue={this.setFormElementData}
            fieldPrefix={this.props.fieldPrefix}
            radioValues={radioValues}
          />
        </div>
      </div>
    );
    return _jsx;
  }

  generateHorizontalLine = ({ name, isVisible }, elementKey) => {
    const visibilityCss = classnames("form-group row", {
      noDisplay: isVisible === 'false'
    });
    const _jsx = (
      <hr key={elementKey}></hr>
    );
    return _jsx;
  }

  generateSweepFrequencyJsx = ({ name, boxLabel, subLabels, subNames, dataDictionaryURI, isVisible, mandatoryMessage, value }, elementKey) => {
    const visibilityCss = classnames("form-group row", {
      noDisplay: isVisible === 'false'
    });
    var disabled
    if (this.isReadOnly()) {
      disabled = true
    }
    var boxLabelTranslated = Translations(boxLabel, this.props.lang, this.props.translatedData);
    var currentWord = Translations(subLabels, this.props.lang, this.props.translatedData)
    var defaultValue = Translations(value, this.props.lang, this.props.translatedData)
    var convertedArray = convertStringToArrayForOption(currentWord);
    var mandatoryMessageTranslated = Translations(mandatoryMessage, this.props.lang, this.props.translatedData)
    var dataDictionaryURI = Translations(dataDictionaryURI, this.props.lang, this.props.translatedData)
    const _jsx = (
      <div key={elementKey} className={visibilityCss} id={`${this.props.fieldPrefix || ""}${name}Field`}>
        <div className="col-lg-12 col-sm-12">
          <SweepFrequencyPicker name={name}
            boxLabel={boxLabelTranslated}
            subLabels={convertedArray}
            subNames={subNames}
            disabled={disabled}
            dataDictionaryURI={dataDictionaryURI}
            defaultValue={defaultValue}
            _value={this.props.properties.formData[name] || this.props.properties[name]}
            setInputvalue={this.setFormElementData}
            fieldPrefix={this.props.fieldPrefix}
            mandatoryMessage={mandatoryMessageTranslated}
            lang={this.props.lang} />
        </div>
      </div>
    );
    return _jsx;
  }

  generateSweepTimeJsx = ({ name, boxLabel, subNames, options, subValues, customTimePlaceholder, defaultValue, isVisible, message, sweepTime_hintText }, elementKey) => {
    const visibilityCss = classnames("form-group row", {
      noDisplay: isVisible === 'false'
    });
    var disabled
    if (this.isReadOnly()) {
      disabled = true
    }
    var boxLabelTranslated = Translations(boxLabel, this.props.lang, this.props.translatedData);
    var messageTranslated = Translations(message, this.props.lang, this.props.translatedData);
    var sweepTime_hintTextTranslated = Translations(sweepTime_hintText, this.props.lang, this.props.translatedData)
    var currentWord = Translations(options, this.props.lang, this.props.translatedData)
    var convertedArray = convertStringToArrayForRadio(currentWord);
    const _jsx = (
      <div key={elementKey} className={visibilityCss} id={`${this.props.fieldPrefix || ""}${name}Field`}>
        <div className="col-lg-12 col-sm-12">
          <SweepTimePicker name={name}
            boxLabel={boxLabelTranslated}
            subLabels={convertedArray}
            id={name}
            subNames={subNames}
            disabled={disabled}
            subValues={subValues}
            customTimePlaceholder={customTimePlaceholder}
            _value={this.props.properties.formData[name] || this.props.properties[name]}
            defaultValue={defaultValue}
            setInputvalue={this.setFormElementData}
            fieldPrefix={this.props.fieldPrefix}
            message={messageTranslated}
            sweepTime_hintText={sweepTime_hintTextTranslated} />
        </div>
      </div>
    );
    return _jsx;
  }

  getCCrRateId = (name, fieldPrefix = '', isAggregate, parentFormName, formIndex) => {
    return isAggregate ? `${fieldPrefix}${name}${parentFormName}${formIndex}Field` : `${fieldPrefix || ""}${name}Field`
  }

  generateCCRRateBoxJsx = ({ name, boxLabel, subLabels, subNames, radioValues, isVisible, maxChars, isAggregate, parentFormName, formData, formIndex, defaultValue }, elementKey) => {
    const visibilityCss = classnames("form-group row", {
      noDisplay: isVisible === 'false'
    });
    var disabled
    if (this.isReadOnly()) {
      disabled = true
    }
    var boxLabelTranslated = Translations(boxLabel, this.props.lang, this.props.translatedData);
    var currentWord = Translations(subLabels, this.props.lang, this.props.translatedData)
    var convertedArray = convertStringToArrayForOption(currentWord);

    const _jsx = (
      <div key={elementKey} className={visibilityCss} id={this.getCCrRateId(name, this.props.fieldPrefix, isAggregate, parentFormName, formIndex)}>
        <div className="col-lg-12 col-sm-12">
          <CCRRateBox
            name={isAggregate ? parentFormName + name + formIndex : name}
            boxLabel={boxLabelTranslated}
            disabled={disabled}
            subLabels={convertedArray}
            subNames={subNames}
            radioValues={radioValues}
            maxChars={maxChars}
            defaultValue={defaultValue}
            _value={isAggregate ? this.getCCRRateValues(this.props.properties.formData, name, formIndex) : (this.props.properties.formData[name] || this.props.properties[name])}
            setInputvalue={isAggregate ? (value, name) => this.setFormElementData(value, name, isAggregate, parentFormName, formData, formIndex) : this.setFormElementData}
            fieldPrefix={this.props.fieldPrefix} />
        </div>
      </div>
    );
    return _jsx;
  }

  getCCRRateValues = (formData, name, formIndex) => {
    const condition = {
      tiersCredit: "accountInterestCreditTiers",
      tiersDebit: "accountInterestDebitTiers",
      tiersUnauthorizedOD: "odLimitTier",
      tiersInterestEarnings: "interestEarnTiers",
      tiersInterestCharges: "interestChargeTiers"
    }

    if (condition[name]) {
      return formData[condition[name]] && formData[condition[name]][formIndex]
    }
    return formData[name] && formData[name][formIndex]
  }

  generateCustomerSearchJsx = ({ title, max, addText, disabled }, elementKey) => {

    const jsx = (<div key={elementKey} className="Customersearchcontainer" id="customer-search-container">
      <EntitySearchBox
        //setSelectedOptions={this.props.getSelectedEntity()}
        AddscustomerTitle={Translations(title, this.props.lang, this.props.translatedData)}
        createNewEntityLinkRoute="/admin-panel/create-edit-case"
        maxLength={max || 70}
        properties={this.props.properties}
        CaseRecordToggle={this.props.CaseRecordToggle}
        lang={this.props.lang}
        checkForConflictsStatus={this.props.checkForConflictsStatus}
        onCreateNewEntity={this.props.onCreateNewEntity}
        setSelectedOptions={this.props.setSelectedOptions}
        disabled={this.props.searchBoxDisabled !== undefined ? this.props.searchBoxDisabled : this.props.formDisabled}
        visible={this.props.searchBoxDisabled !== undefined ? this.props.searchBoxDisabled : false}
        translatedData={this.props.translatedData}
        addText={addText} />
    </div>
    );
    return jsx;
  }


  generateSearchJsx = ({ title, name, max, mandatory, addText, disabled }, elementKey) => {

    const jsx = (<div key={elementKey} className="form-group row">
      <label for={name} className="col-lg-4">{Translations(title, this.props.lang, this.props.translatedData)}</label>
      <div className="col-lg-8 col-sm-12">
        <SearchBox
          //setSelectedOptions={this.props.getSelectedEntity()}
          label={Translations(title, this.props.lang, this.props.translatedData)}
          maxLength={max || 70}
          id={name}
          options={this.props.options}
          showOptions={this.props.showOptions}
          routingFlag={this.props.routingFlag}
          properties={this.props.properties}
          mandatory={mandatory}
          lang={this.props.lang}
          selectedOptionValue={this.props.properties.formData[name]}
          setInputvalue={this.setFormElementData}
          setFieldValidtionState={this.setFieldValidtionState}
          filterList={this.props.filterList}
          setSelectedOptions={this.props.setSelectedOptions}
          disabled={this.props.searchBoxDisabled !== undefined ? this.props.searchBoxDisabled : this.props.formDisabled}
          visible={this.props.searchBoxDisabled !== undefined ? this.props.searchBoxDisabled : false}
          translatedData={this.props.translatedData}
          addText={addText} />
      </div>
    </div>
    );
    return jsx;
  }

  generateSimpleDropdownJsx = ({ name, options, title }, elementKey) => {

  }


  getTempRefForAccount = (tempRefId) => {
    this.setState(prevState => {
      var formData = prevState.formData;
      formData['tempRefrenceId'] = tempRefId;
      return { formData };
    });
  }

  renderFormGroups = () => {
    var elements = [];
    var formButtons = [];
    var saveButton = [];
    if (this.state.formSchema !== undefined && this.state.formSchema.guideContainer.rootPanel !== undefined) {

      const formListItems = this.state.formSchema.guideContainer.rootPanel.items;
      let formItems = formListItems;
      if (this.state.formData.odLimit === undefined || this.state.formData.odLimit === null ||
        (this.state.formData.odLimit && typeof this.state.formData.odLimit === "string" && this.state.formData.odLimit.toLowerCase() === "n/a")) {
        const { guideinterestcombobox_unAuthorisedOD, guideradiobutton_unauthorizedInterestType, guideccrrate_unAuthorizedOD, ...rest } = formListItems;
        formItems = rest;
      }

      for (var elementKey in formItems) {
        if (elementKey.startsWith('guidetextbox')) {
          elements.push(this.generateInputBoxJsx(formItems[elementKey], elementKey));
        } else if (elementKey.startsWith('guidedatepicker')) {
          elements.push(this.generateDatePickerJsx(formItems[elementKey], elementKey));
        } else if (elementKey.startsWith('autoCompleteTextBox')) {
          elements.push(this.generateAutoCompleteTextBoxJsx(formItems[elementKey], elementKey));
        } else if (elementKey.startsWith('table_servicehistory')) {
          elements.push(this.generateTableOps(formItems[elementKey], elementKey));
        } else if (elementKey.startsWith('guideradiobutton')) {
          elements.push(this.generateRadioButtonJsx(formItems[elementKey], elementKey));
        } else if (elementKey.startsWith('guidedropdownlist')) {
          elements.push(this.generateDropdownJsx(formItems[elementKey], elementKey));
        } else if (elementKey.startsWith('static_text')) {
          elements.push(this.generateTextJsx(formItems[elementKey], elementKey));
        } else if (elementKey.startsWith('guidebutton_cancel')) {
          formButtons.push(this.generateCanelButtonJsx(formItems[elementKey], elementKey));
        } else if (elementKey.startsWith('guidebutton_saveAndNext')) {
          formButtons.push(this.generateSubmitButtonJsx(formItems[elementKey], elementKey));
        } else if (elementKey.startsWith('guidebutton_submit')) {
          formButtons.push(this.generateSubmitButtonJsx(formItems[elementKey], elementKey));
        } else if (elementKey.startsWith('guidebutton_saveAndRefresh')) {
          saveButton.push(this.generateSubmitButtonJsx(formItems[elementKey], elementKey))
        } else if (elementKey.startsWith('guideMultiDropdownlist')) {
          elements.push(this.generateMultiSelectJsx(formItems[elementKey], elementKey));
          //elements.push(this.generateSingleSelectJsx(formItems[elementKey], elementKey));
        } else if (elementKey.startsWith('guideSowDropdownlist')) {
          elements.push(this.generateMultiSelectJsx1(formItems[elementKey], elementKey));
          //elements.push(this.generateSingleSelectJsx(formItems[elementKey], elementKey));
        }
        else if (elementKey.startsWith('guidedsingleselect')) {
          elements.push(this.generateSingleSelectJsx(formItems[elementKey], elementKey));
        } else if (elementKey.startsWith('guidepasswordbox')) {
          elements.push(this.generatePasswordJsx(formItems[elementKey], elementKey));
        } else if (elementKey.startsWith('guidecombobox')) {
          elements.push(this.generateComboBoxJsx(formItems[elementKey], elementKey));
        } else if (elementKey.startsWith('guideoptionaltextbox')) {
          elements.push(this.generateOptionalTextBox(formItems[elementKey], elementKey));
        } else if (elementKey.startsWith('guideinterestcombobox')) {
          elements.push(this.generateInterestComboBox(formItems[elementKey], elementKey));
        } else if (elementKey.startsWith('guideseparator')) {
          elements.push(this.generateHorizontalLine(formItems[elementKey], elementKey));
        } else if (elementKey.startsWith('guidesweepfrequency')) {
          elements.push(this.generateSweepFrequencyJsx(formItems[elementKey], elementKey));
        } else if (elementKey.startsWith('guidesweeptime')) {
          elements.push(this.generateSweepTimeJsx(formItems[elementKey], elementKey));
        } else if (elementKey.startsWith('guideccrrate')) {
          elements.push(this.generateCCRRateBoxJsx(formItems[elementKey], elementKey));
        } else if (elementKey.startsWith('guideformheader')) {
          elements.push(this.generateFormHeaderJsx(formItems[elementKey], elementKey));
        } else if (elementKey.startsWith('guidereadonlytext')) {
          elements.push(this.generateReadonlytextJsx(formItems[elementKey], elementKey));
        } else if (elementKey.startsWith('guidebutton_save')) {
          saveButton.push(this.generateSubmitButtonJsx(formItems[elementKey], elementKey));
        } else if (elementKey.startsWith('guidenestedcheckbox')) {
          elements.push(this.generateNestedCheckBoxJsx(formItems[elementKey], elementKey));
        } else if (elementKey.startsWith('type_ahead_customerSearch')) {
          elements.push(this.generateCustomerSearchJsx(formItems[elementKey], elementKey));
        } else if (elementKey.startsWith('type_ahead')) {
          elements.push(this.generateSearchJsx(formItems[elementKey], elementKey));
        }
        else if (elementKey.startsWith('type_sowEntityList')) {
          elements.push(this.getAddEntityJsx(formItems[elementKey], elementKey));
        }
        else if (elementKey.startsWith('type_sowAddEntity')) {
          elements.push(this.getEntityListJsx(formItems[elementKey], elementKey));
        }
        else if (elementKey.startsWith('guideaggregateformbox')) {
          elements.push(this.renderAggregateTierRangeDetailsJsx(formItems[elementKey], elementKey));
        } else if (elementKey.startsWith('guidesimpledropdownlist')) {
          elements.push(this.generateSimpleDropdownJsx(formItems[elementKey], elementKey));
        }
      }
    }

    elements.push(<div key="create-entity-form-clear" className="gdocs-clear-float"></div>);
    if (!this.props.hideButtons) {
      elements.push(
        <div key="buttons-wrapper" className="form-buttons-section">
          <div className="form-buttons-wrapper">
            {formButtons}
          </div>
        </div>
      );
    }

    if (this.props.saveButton && saveButton.length > 0) {
      elements.push(
        <div key="buttons-wrapper" className="form-buttons-save-section">
          <div className="form-buttons-wrapper">
            {saveButton}
          </div>
        </div>
      );
    }
    return elements;
  }

  formblur = () => {
    this.props.getFormData(this.state.formData);
  }

  /* Code fo Date Selector*/
  action(name) {
    return name;
  }

  logAction(name) {
    return this.action;
  }

  //Modal to dsiplay help text for Banking and Non-Banking Customer
  renderBankingNonBankingHelpTextModal = () => {
    const { helptext = '', redBtn = 'OK', title = '' } = this.state.formSchema && this.state.formSchema.guideContainer &&
      this.state.formSchema.guideContainer.rootPanel && this.state.formSchema.guideContainer.rootPanel.items ?
      this.state.formSchema.guideContainer.rootPanel.items.modal_bankingNonBankingHelptext : {}
    return (
      <Modal
        show={this.state.showBankingNonBankingHelpTextModal}
        onClose={() => { this.setState({ showBankingNonBankingHelpTextModal: false }) }}
        bsClass={"bnk-non-bnk-help-text-modal"}>
        <ModalHeader title={this.getTranslation(title)} />
        <ModalBody>
          <section className="bnk-non-bnk-help-text" >
            {this.getTranslation(helptext)}
          </section>
        </ModalBody>
        <ModalFooter>
          <button
            className="gdocs-btn-primary"
            onClick={() => { this.setState({ showBankingNonBankingHelpTextModal: false }) }}
          >
            {this.getTranslation(redBtn)}
          </button>
        </ModalFooter>
      </Modal>
    )
  }

  getTranslation = (value) => {
    return Translations(value, this.props.lang, this.props.translatedData)
  }

  getEntityListJsx = (itemObj, elementKey) => {
    const { entityList } = this.props


    const generateRows = (list = []) => {
      return list.map((li, index) => (
        <React.Fragment>
          <li className='create-sow-list-item'>
            <span className='create-sow-list-item__entity-name'>
              {li.registeredName} - {li.countryOfIncorporation.name}
            </span>
            <button
              className="gdocs-btn-icon delete-btn"
              aria-label={`Delete Entity: ${li.registeredName} - ${li.countryOfIncorporation.name}`}
              onClick={(e) => {
                e.preventDefault();
                this.props.handleDeleteEntityList(e, index);
              }}
              disabled={li.agent === true}
            >
              <i className="icon icon-bin" disabled={li.agent === true}></i>
            </button>
          </li>
        </React.Fragment>
      ))
    }

    return (
      <article className='form-group row sow-gls-list'>
        <ul className='list-item-wrapper'>
          {generateRows(entityList)}
        </ul>
      </article>
    )
  }

  getAddEntityJsx = ({ text = "Add Customer" }, elementKey) => {
    const { registeredName, countryOfIncorporation } = this.state.formData
    return (
      <section className='form-group row sow-add-entity'>
        <button
          className="gdocs-btn-default"
          disabled={!(registeredName && countryOfIncorporation)}
          onClick={(e) => {
            e.preventDefault();
            const inputTextbox = document.querySelector("[name='registeredName']");
            if (inputTextbox) {
              inputTextbox.focus();
            }
            this.props.handleAddEntity();
          }}
        >
          <span class="icon icon-add addicon"></span>
          {this.getTranslation(text)}
        </button>
      </section>
    )
  }

  renderAggregateTierRangeDetailsJsx = ({ components, name: formName, addItemButton }, elementKey) => {
    if (typeof elementKey === "string" && !elementKey.includes("Tier")) {
      return
    }
    const componentList = getAggregateFormComponents(components, this.props.lang, this.props.translatedData)

    const formCondition = {
      interestChargeTiers: "interestChargesTierStatus",
      interestEarnTiers: "interestEarnTierStatus",
      accountInterestCreditTiers: "accountCreditTierStatus",
      accountInterestDebitTiers: "accountDebitTierStatus",
      odLimitTier: "odLimitTierStatus"
    }

    let isShowTiering = this.state.formData && formCondition[formName] && this.state.formData[formCondition[formName]] && (
      this.state.formData[formCondition[formName]] !== "notiering")

    const key = "tier-range-details"
    const idPrefix = ""

    const handleFormChange = (value, name, formName, formIndex) => {
      const newFormData = { ...this.state.formData }
      if (formName) {
        if (newFormData[formName] && newFormData[formName][formIndex]) {
          newFormData[formName][formIndex] = { ...newFormData[formName][formIndex], [name]: value }
        } else {
          newFormData[formName] = [{ [name]: value }]
        }
        this.setState({
          formData: { ...this.state.formData, [formName]: newFormData[formName] }
        })
      }
    }

    const handleFormValidation = (field, isValid) => {

    }

    const tierObj = { from: "", to: "" }

    const tierRange = (this.state.formData[formName] && this.state.formData[formName].length && this.state.formData[formName]) || [tierObj, tierObj]

    const handleAddTier = (formName) => {
      if (formName) {
        let newFormData = { ...this.state.formData }
        if (newFormData[formName] && newFormData[formName].length) {
          newFormData[formName] = [...newFormData[formName], tierObj]
        }
        else {
          newFormData[formName] = [...tierRange, tierObj]
        }
        this.setState({
          formData: { ...this.state.formData, [formName]: newFormData[formName] }
        })
      }
    }

    const handleDeleteTier = (formName, formIndex) => {

      if (this.props.sow && this.isReadOnly()) {
        return
      } else {
        if (formIndex > -1 && this.state.formData[formName] && this.state.formData[formName][formIndex]) {
          this.setState({
            formData: { ...this.state.formData, [formName]: this.state.formData[formName].filter((el, elIndex) => elIndex !== formIndex) }
          })
        }
      }
    }


    const tierComponentJsx = (formData, formIndex) => componentList.map((component, componentIndex) => {
      const { fieldType = '', name = '', type = '', label = '', apiUrl = '', title = '', header = '', mandatory = "", mandatoryMessage, ccrRate = {} } = component
      switch (fieldType) {
        case "inputField":
          return (
            <section className="form-row-container" key={key + "-in" + componentIndex}>
              <section className="form-row-label">
                <label htmlFor={`${formName}_${formIndex}_${name}_${componentIndex}`}>
                  {this.getTranslation(label)}
                </label>
              </section>
              <section className="form-row-field">
                <InputTextbox
                  name={`${formName}_${formIndex}_${name}_${componentIndex}`}
                  id={`${idPrefix}-${formName}_${formIndex}_${name}_${componentIndex}`}
                  setInputvalue={(value) => { handleFormChange(value, name, formName, formIndex) }}
                  type={type}
                  _value={formData[name] || ''}
                  mandatory={mandatory}
                  mandatoryMessage={this.getTranslation(mandatoryMessage)}
                  setFieldValidtionState={(field, isValid) => {
                    handleFormValidation(field, isValid)
                  }}
                  disabled={this.props.sow && this.isReadOnly()}
                ></InputTextbox>
              </section>
            </section>
          )

        case "formTitle":
          return (
            <article style={{
              display: "flex",
              justifyContent: "space-between"
            }} key={key + "-tt" + componentIndex}>
              <section className='gdocs-mb-0p5'>
                <strong>  {formData.tierRefId || `${this.getTranslation(title)} ${formIndex + 1}`}</strong>
              </section>
              {deleteIconJsx(formIndex)}
            </article>
          )
        case "radioButton":
          return (
            <section className='form-row-container'>
              <section className='radio-label'>
                {this.getTranslation(label)}
              </section>

              <section
                className="negative-margin-options-container"
                role="radiogroup"
                aria-label={""}
              >
                <label>
                  Yes
                  <RadioButton
                    setInputvalue={(value) => { handleFormChange(value, name, formName, formIndex) }}
                    name={`${formName}_${formIndex}_${name}_${componentIndex}`}
                    _value={formData[name] || false}
                    value={true}
                    disabled={this.props.sow && this.isReadOnly()}
                  ></RadioButton>
                </label>
                <label>
                  No
                  <RadioButton
                    setInputvalue={(value) => { handleFormChange(value, name, formName, formIndex) }}
                    name={`${formName}_${formIndex}_${name}_${componentIndex}`}
                    _value={formData[name] || false}
                    value={false}
                    disabled={this.props.sow && this.isReadOnly()}
                  ></RadioButton>
                </label>
              </section>
            </section >
          )
        case "ccrRate":
          return ccrRateJsx(formData, formIndex, ccrRate)
        default:
          break;
      }
    }
    )

    const deleteIconJsx = (formIndex) => formIndex > 0 ? <section class="delete-icon" id={formName + "_" + formIndex} onClick={() => {
      handleDeleteTier(formName, formIndex)
    }}><i tabindex="0" class="icon icon-bin"></i></section> : null

    const addTierButtonJsx = (formName, label = "Add Tier") => {
      return 1 ?
        <section className='gdocs-mt-0p5'>
          <button class="gdocs-btn-default" id={"add-" + formName + tierRange.length + 1} onClick={(e) => { e.preventDefault(); handleAddTier(formName) }} disabled={this.props.sow && this.isReadOnly()}>
            <span class="icon icon-add addicon">
            </span>{`${this.getTranslation(label)} ${tierRange.length + 1}`}
          </button>
        </section> : null
    }

    if (!isShowTiering && this.state.formData[formName] && this.state.formData[formName].length) {
      this.setState({
        formData: { ...this.state.formData, [formName]: [] }
      })

    }

    const ccrRateJsx = (formData, formIndex, ccrRate = {}) => {
      return isEmptyObject(ccrRate) ? null : this.generateCCRRateBoxJsx({ ...ccrRate, isAggregate: true, parentFormName: ccrRate.name, formData, formIndex }, "ccrRate" + ccrRate.name)
    }

    return (
      <React.Fragment>
        {
          isShowTiering ?
            <section className="sow-add-tier-range ccr-rate-box__combo-box">
              {
                tierRange.map((tier, tierIndex) => (
                  tierComponentJsx(tier, tierIndex)
                ))
              }
              {
                addTierButtonJsx(formName, addItemButton, 0)
              }
            </section>
            : null
        }
      </React.Fragment>)
  }

  checkGLSNPIOPoolAccount = (type) => {
    if (this.props.properties && this.props.properties.editType) {
      const [product, accountType = ''] = this.props.properties.editType.split('_') || []
      if (product === 'gls-np-interest-optimisation') {
        return accountType.includes(type)
      }
    }
  }

  render() {
    const formDataExists = Object.keys(this.props.properties.formData).length > 0;
    return (
      <div>
        <form className="formcontainer" onBlur={this.formblur} ref={r => this.formRefResolved(r)}>
          {this.props.properties.pathname.includes("/create-a-case/create-new-account") ? (<em>({this.props.pageJson !== undefined ? Translations(this.props.pageJson.par.page_title_mainTitle.subtitle, this.props.lang, this.props.translatedData) : ''} {this.state.formData['tempRefrenceId']})</em>) : ''}
          {this.props.properties.pathname.includes("/case-body/create-new-account") ? (<em>({this.props.pageJson !== undefined ? Translations(this.props.pageJson.par.page_title_mainTitle.subtitle, this.props.lang, this.props.translatedData) : ''} {this.state.formData['tempRefrenceId']})</em>) : ''}
          {this.props.properties.pathname.includes("/case-body/create-new-echannel") ? (<em>({this.props.pageJson !== undefined ? Translations(this.props.pageJson.par.page_title_mainTitle.subtitle, this.props.lang, this.props.translatedData) : ''} {this.state.formData['tempRefrenceId']})</em>) : ''}
          {this.props.mode === 'edit' ? (formDataExists ? this.renderFormGroups() : (<h4>Loading form data....</h4>)) : this.renderFormGroups()}
          {this.props.properties.bankingNonBankingHelpTextModal ? this.renderBankingNonBankingHelpTextModal() : null}
        </form>
      </div>
    )
  }


  //DGT-6804 cash con crash issue- code commneted due to causing issue in multiple textfield
  // shouldComponentUpdate(nextProps, nextStates) {
  //   return JSON.stringify(this.state) !== JSON.stringify(nextStates)
  // }
}

const mapStateToProps = state => {
  return {
    cases: state.cases,
    newEntities: state.newEntities,
    oldEntities: state.oldEntities,
    currentCustomerDetailsEntityId: state.currentCustomerDetails.data.entityId,
    currentProductEchannel: state.currentProductEchannel,
    owningCase: state.darkTitleBar.currentCase,
    customer: state.auth.userDetails,
    admin: isAdmin(state.auth),
    caseMenu: state.caseMenuInfo
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setCountryInfo: assocaitions => {
      dispatch(setCountryInfo(assocaitions))
    },
    setCurrencyInfo: currencyInfo => {
      dispatch(setCurrencyInfo(currencyInfo))
    }
  }
}

Dynamicform.defaultProps = {
  forceValidations: false,
  formTouched: false,
  formInvalid: true
}

Dynamicform.propTypes = {
  forceValidations: PropTypes.bool,
  formTouched: PropTypes.bool,
  formInvalid: PropTypes.bool,
  properties: PropTypes.object,
  mode: PropTypes.string,
  fieldPrefix: PropTypes.string,
  getFormData: PropTypes.func.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(Dynamicform);



// WEBPACK FOOTER //
// ./src/components/common/Dynamicform/dynamicForm.js